"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Apply = require("../Control.Apply/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Reader = require("../Control.Monad.Reader/index.js");
var Control_Monad_Reader_Class = require("../Control.Monad.Reader.Class/index.js");
var Control_Monad_Reader_Trans = require("../Control.Monad.Reader.Trans/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Array_NonEmpty_Internal = require("../Data.Array.NonEmpty.Internal/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Traversable = require("../Data.Traversable/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Events = require("../Halogen.HTML.Events/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Haskell_AST = require("../Haskell.AST/index.js");
var Haskell_Token = require("../Haskell.Token/index.js");
var Safe_Coerce = require("../Safe.Coerce/index.js");
var Web_HTML_Common = require("../Web.HTML.Common/index.js");
var SClass = function (x) {
    return x;
};
var Opt01 = (function () {
    function Opt01() {

    };
    Opt01.value = new Opt01();
    return Opt01;
})();
var Star = (function () {
    function Star() {

    };
    Star.value = new Star();
    return Star;
})();
var Plus = (function () {
    function Plus() {

    };
    Plus.value = new Plus();
    return Plus;
})();
var NodeToken = (function () {
    function NodeToken(value0) {
        this.value0 = value0;
    };
    NodeToken.create = function (value0) {
        return new NodeToken(value0);
    };
    return NodeToken;
})();
var NodeTag = (function () {
    function NodeTag(value0) {
        this.value0 = value0;
    };
    NodeTag.create = function (value0) {
        return new NodeTag(value0);
    };
    return NodeTag;
})();
var N = (function () {
    function N(value0) {
        this.value0 = value0;
    };
    N.create = function (value0) {
        return new N(value0);
    };
    return N;
})();
var T = (function () {
    function T(value0) {
        this.value0 = value0;
    };
    T.create = function (value0) {
        return new T(value0);
    };
    return T;
})();
var K = (function () {
    function K(value0) {
        this.value0 = value0;
    };
    K.create = function (value0) {
        return new K(value0);
    };
    return K;
})();
var Grp = (function () {
    function Grp(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Grp.create = function (value0) {
        return function (value1) {
            return new Grp(value0, value1);
        };
    };
    return Grp;
})();
var SyntaxRule = (function () {
    function SyntaxRule(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    SyntaxRule.create = function (value0) {
        return function (value1) {
            return new SyntaxRule(value0, value1);
        };
    };
    return SyntaxRule;
})();
var Report2010 = (function () {
    function Report2010(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Report2010.create = function (value0) {
        return function (value1) {
            return new Report2010(value0, value1);
        };
    };
    return Report2010;
})();
var Highlight = function (x) {
    return x;
};
var Idle = (function () {
    function Idle() {

    };
    Idle.value = new Idle();
    return Idle;
})();
var Focused = (function () {
    function Focused(value0) {
        this.value0 = value0;
    };
    Focused.create = function (value0) {
        return new Focused(value0);
    };
    return Focused;
})();
var Syntax = (function () {
    function Syntax(value0) {
        this.value0 = value0;
    };
    Syntax.create = function (value0) {
        return new Syntax(value0);
    };
    return Syntax;
})();
var Links = (function () {
    function Links(value0) {
        this.value0 = value0;
    };
    Links.create = function (value0) {
        return new Links(value0);
    };
    return Links;
})();
var NodeDescr = function (x) {
    return x;
};
var Summary = function (summary) {
    this.summary = summary;
};
var Ahead = function (x) {
    return x;
};
var Click = (function () {
    function Click(value0) {
        this.value0 = value0;
    };
    Click.create = function (value0) {
        return new Click(value0);
    };
    return Click;
})();
var Hover = (function () {
    function Hover(value0) {
        this.value0 = value0;
    };
    Hover.create = function (value0) {
        return new Hover(value0);
    };
    return Hover;
})();
var Unhover = (function () {
    function Unhover(value0) {
        this.value0 = value0;
    };
    Unhover.create = function (value0) {
        return new Unhover(value0);
    };
    return Unhover;
})();
var NodeHover = (function () {
    function NodeHover(value0) {
        this.value0 = value0;
    };
    NodeHover.create = function (value0) {
        return new NodeHover(value0);
    };
    return NodeHover;
})();
var NodeUnhover = (function () {
    function NodeUnhover() {

    };
    NodeUnhover.value = new NodeUnhover();
    return NodeUnhover;
})();
var Match = (function () {
    function Match(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Match.create = function (value0) {
        return function (value1) {
            return new Match(value0, value1);
        };
    };
    return Match;
})();
var NoMatch = (function () {
    function NoMatch() {

    };
    NoMatch.value = new NoMatch();
    return NoMatch;
})();
var ADoc = function (x) {
    return x;
};
var Node = function (x) {
    return x;
};
var Render = function (render) {
    this.render = render;
};

// | Just produce the list of nodes
var Renders = function (renders) {
    this.renders = renders;
};
var tokenC = "token";
var tagC = function ($599) {
    return Web_HTML_Common.ClassName((function (v) {
        if (v instanceof Haskell_Token.Ident) {
            return "ident";
        };
        if (v instanceof Haskell_Token.Special) {
            return "special";
        };
        if (v instanceof Haskell_Token.ModId) {
            return "modid";
        };
        if (v instanceof Haskell_Token.Keyword) {
            return "keyword";
        };
        if (v instanceof Haskell_Token.PseudoKeyword) {
            return "pseudokeyword";
        };
        if (v instanceof Haskell_Token.LitInteger) {
            return "litinteger";
        };
        if (v instanceof Haskell_Token.LitFloat) {
            return "litfloat";
        };
        if (v instanceof Haskell_Token.LitChar) {
            return "litchar";
        };
        if (v instanceof Haskell_Token.LitString) {
            return "litstring";
        };
        if (v instanceof Haskell_Token.Eof) {
            return "eof";
        };
        throw new Error("Failed pattern match at Haskell.Render (line 1305, column 24 - line 1315, column 15): " + [ v.constructor.name ]);
    })($599));
};
var summaryTopDecl = new Summary(function ($600) {
    return NodeDescr((function (v) {
        if (v instanceof Haskell_AST.Decl_) {
            return {
                name: "simple declaration",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.TypeDecl) {
            return {
                name: "type synonym",
                descr: [ new Links([ new Report2010("Type synonym declarations", "https://www.haskell.org/onlinereport/haskell2010/haskellch4.html#x10-730004.2.2") ]) ]
            };
        };
        if (v instanceof Haskell_AST.DataDecl) {
            return {
                name: "data type",
                descr: [ new Links([ new Report2010("Algebraic datatype declarations", "https://www.haskell.org/onlinereport/haskell2010/haskellch4.html#x10-690004.2.1") ]) ]
            };
        };
        if (v instanceof Haskell_AST.NewtypeDecl) {
            return {
                name: "newtype",
                descr: [ new Links([ new Report2010("Datatype renamings", "https://www.haskell.org/onlinereport/haskell2010/haskellch4.html#x10-740004.2.3") ]) ]
            };
        };
        if (v instanceof Haskell_AST.ClassDecl) {
            return {
                name: "class",
                descr: [ new Links([ new Report2010("Class declarations", "https://www.haskell.org/onlinereport/haskell2010/haskellch4.html#x10-760004.3.1") ]) ]
            };
        };
        if (v instanceof Haskell_AST.InstDecl) {
            return {
                name: "instance",
                descr: [ new Links([ new Report2010("Instance declarations", "https://www.haskell.org/onlinereport/haskell2010/haskellch4.html#x10-770004.3.2") ]) ]
            };
        };
        if (v instanceof Haskell_AST.DefaultDecl) {
            return {
                name: "default declaration",
                descr: [ new Links([ new Report2010("Ambiguous types, and defaults for overloaded numeric operations", "https://www.haskell.org/onlinereport/haskell2010/haskellch4.html#x10-790004.3.4") ]) ]
            };
        };
        throw new Error("Failed pattern match at Haskell.Render (line 831, column 27 - line 870, column 107): " + [ v.constructor.name ]);
    })($600));
});
var summaryStmt = function ($601) {
    return NodeDescr((function (v) {
        if (v instanceof Haskell_AST.GuardPat) {
            return {
                name: "do bind",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.GuardLet) {
            return {
                name: "do let",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.GuardBool) {
            return {
                name: "do expr",
                descr: [  ]
            };
        };
        throw new Error("Failed pattern match at Haskell.Render (line 508, column 29 - line 517, column 19): " + [ v.constructor.name ]);
    })($601));
};
var summaryQual = new Summary(function (v) {
    if (v instanceof Haskell_AST.GuardPat) {
        return {
            name: "generator (list comprehension)",
            descr: [  ]
        };
    };
    if (v instanceof Haskell_AST.GuardLet) {
        return {
            name: "let (list comprehension)",
            descr: [  ]
        };
    };
    if (v instanceof Haskell_AST.GuardBool) {
        return {
            name: "guard (list comprehension)",
            descr: [  ]
        };
    };
    throw new Error("Failed pattern match at Haskell.Render (line 571, column 32 - line 580, column 21): " + [ v.constructor.name ]);
});
var summaryPat = new Summary(function ($602) {
    return NodeDescr((function (v) {
        if (v instanceof Haskell_AST.PVar) {
            return {
                name: "variable pattern",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.PInfix) {
            return {
                name: "infix constructor pattern",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.PCon) {
            return {
                name: "nullary constructor pattern",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.PApp) {
            return {
                name: "constructor pattern",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.PLit) {
            return {
                name: "literal pattern",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.PNeg) {
            return {
                name: "negative literal pattern",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.PIrrefutable) {
            return {
                name: "irrefutable pattern",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.PWild) {
            return {
                name: "wildcard pattern",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.PPar) {
            return {
                name: "parenthesis pattern",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.PTuple) {
            return {
                name: "tuple pattern",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.PList) {
            return {
                name: "list pattern",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.PRecord) {
            return {
                name: "record pattern",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.PAs) {
            return {
                name: "as-pattern",
                descr: [  ]
            };
        };
        throw new Error("Failed pattern match at Haskell.Render (line 1011, column 27 - line 1050, column 21): " + [ v.constructor.name ]);
    })($602));
});
var summaryImpSpec = new Summary(function (v) {
    if (v instanceof Haskell_AST.ImportHiding) {
        return {
            name: "import hiding",
            descr: [  ]
        };
    };
    if (v instanceof Haskell_AST.ImportExplicit) {
        return {
            name: "import explicit",
            descr: [  ]
        };
    };
    throw new Error("Failed pattern match at Haskell.Render (line 797, column 13 - line 803, column 21): " + [ v.constructor.name ]);
});
var summaryIDecl = new Summary(function (v) {
    if (v instanceof Haskell_AST.IDecl) {
        return {
            name: "instance method",
            descr: [  ]
        };
    };
    if (v instanceof Haskell_AST.IDeclEmpty) {
        return {
            name: "empty idecl",
            descr: [  ]
        };
    };
    throw new Error("Failed pattern match at Haskell.Render (line 915, column 1 - line 921, column 19): " + [ v.constructor.name ]);
});
var summaryGuard = new Summary(function ($603) {
    return NodeDescr((function (v) {
        if (v instanceof Haskell_AST.GuardPat) {
            return {
                name: "pattern guard",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.GuardLet) {
            return {
                name: "guard declaration",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.GuardBool) {
            return {
                name: "boolean guard",
                descr: [  ]
            };
        };
        throw new Error("Failed pattern match at Haskell.Render (line 583, column 27 - line 592, column 21): " + [ v.constructor.name ]);
    })($603));
});
var summaryGTyCon = function ($604) {
    return NodeDescr((function (v) {
        if (v instanceof Haskell_AST.TyArrowCon) {
            return {
                name: "arrow type constructor",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.TyUnit) {
            return {
                name: "unit type",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.TyNil) {
            return {
                name: "list type constructor",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.TyTupleCon) {
            return {
                name: "tuple type constructor",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.TyCon) {
            return {
                name: "type constructor",
                descr: [  ]
            };
        };
        throw new Error("Failed pattern match at Haskell.Render (line 647, column 31 - line 662, column 19): " + [ v.constructor.name ]);
    })($604));
};
var summaryTy = new Summary(function ($605) {
    return NodeDescr((function (v) {
        if (v instanceof Haskell_AST.TyVar) {
            return {
                name: "type variable",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.TyApp) {
            return {
                name: "type application",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.TyPar) {
            return {
                name: "parentheses",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.TyArr) {
            return {
                name: "function type",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.TyTuple) {
            return {
                name: "tuple type",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.TyList) {
            return {
                name: "list type",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.TyGCon) {
            var v1 = summaryGTyCon(v.value0);
            return v1;
        };
        throw new Error("Failed pattern match at Haskell.Render (line 625, column 27 - line 644, column 55): " + [ v.constructor.name ]);
    })($605));
});
var summaryGCon = new Summary(function ($606) {
    return NodeDescr((function (v) {
        if (v instanceof Haskell_AST.Unit) {
            return {
                name: "unit",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.Nil) {
            return {
                name: "nil",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.TupleCon) {
            return {
                name: "tuple constructor",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.Con) {
            return {
                name: "con",
                descr: [  ]
            };
        };
        throw new Error("Failed pattern match at Haskell.Render (line 481, column 27 - line 493, column 21): " + [ v.constructor.name ]);
    })($606));
});
var summaryEximport = function (exim) {
    return function ($607) {
        return NodeDescr((function (v) {
            if (v instanceof Haskell_AST.ImportFun) {
                return {
                    name: exim + " function",
                    descr: [  ]
                };
            };
            if (v instanceof Haskell_AST.ImportCon) {
                return {
                    name: exim + " type constructor",
                    descr: [  ]
                };
            };
            if (v instanceof Haskell_AST.ImportConItems) {
                return {
                    name: exim + " type and members",
                    descr: [  ]
                };
            };
            if (v instanceof Haskell_AST.ImportConAll) {
                return {
                    name: exim + " type and all members",
                    descr: [  ]
                };
            };
            throw new Error("Failed pattern match at Haskell.Render (line 733, column 38 - line 745, column 19): " + [ v.constructor.name ]);
        })($607));
    };
};
var summaryExport = new Summary(function (v) {
    if (v instanceof Haskell_AST.ExportImport) {
        return summaryEximport("export")(v.value0);
    };
    if (v instanceof Haskell_AST.ExportModule) {
        return {
            name: "reexport module",
            descr: [  ]
        };
    };
    throw new Error("Failed pattern match at Haskell.Render (line 719, column 13 - line 723, column 21): " + [ v.constructor.name ]);
});
var summaryAlt = new Summary(function ($608) {
    return NodeDescr((function (v) {
        if (v instanceof Haskell_AST.AltSimple) {
            return {
                name: "alternative",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.AltGuard) {
            return {
                name: "guarded alternative",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.AltEmpty) {
            return {
                name: "empty alternative",
                descr: [  ]
            };
        };
        throw new Error("Failed pattern match at Haskell.Render (line 534, column 27 - line 543, column 21): " + [ v.constructor.name ]);
    })($608));
});
var summary = function (dict) {
    return dict.summary;
};
var summaryExp = new Summary(function ($609) {
    return NodeDescr((function (v) {
        if (v instanceof Haskell_AST.If) {
            return {
                name: "if",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.Fun) {
            return {
                name: "fun",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.Let) {
            return {
                name: "let",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.Par) {
            return {
                name: "par",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.Do) {
            return {
                name: "do",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.Case) {
            return {
                name: "case",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.Record && v.value0.e instanceof Haskell_AST.GCon) {
            return {
                name: "record construction",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.Record) {
            return {
                name: "record update",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.Infix) {
            return {
                name: "infix",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.LSection) {
            return {
                name: "left section",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.RSection) {
            return {
                name: "right section",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.App) {
            return {
                name: "app",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.Negate) {
            return {
                name: "negate",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.HasType) {
            return {
                name: "sig",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.Var) {
            return {
                name: "var",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.List) {
            return {
                name: "list",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.EnumList) {
            return {
                name: "enum list",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.ListComp) {
            return {
                name: "list comprehension",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.Tuple) {
            return {
                name: "tuple",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.GCon) {
            return {
                name: "constructor",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.Lit) {
            return {
                name: "literal",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.ExpInfo) {
            var v1 = summary(summaryExp)(v.value1);
            return v1;
        };
        throw new Error("Failed pattern match at Haskell.Render (line 404, column 27 - line 468, column 52): " + [ v.constructor.name ]);
    })($609));
});
var srClass = function (s) {
    return "sr-" + s;
};
var spaceC = "space";
var semigroupMatch = new Data_Semigroup.Semigroup(function (v) {
    return function (v1) {
        if (v instanceof Match) {
            return v;
        };
        if (v instanceof NoMatch) {
            return v1;
        };
        throw new Error("Failed pattern match at Haskell.Render (line 128, column 1 - line 130, column 23): " + [ v.constructor.name, v1.constructor.name ]);
    };
});
var semigroupAhead = function (dictSemigroup) {
    return new Data_Semigroup.Semigroup(function (v) {
        return function (v1) {
            return {
                before: v.before,
                here: Data_Semigroup.append(dictSemigroup)(v.here)(Data_Semigroup.append(dictSemigroup)(v1.before)(v1.here))
            };
        };
    });
};
var semigroupADoc = semigroupAhead(Data_Semigroup.semigroupRecord()(Data_Semigroup.semigroupRecordCons(new Data_Symbol.IsSymbol(function () {
    return "html";
}))()(Data_Semigroup.semigroupRecordCons(new Data_Symbol.IsSymbol(function () {
    return "match";
}))()(Data_Semigroup.semigroupRecordNil)(semigroupMatch))(Data_Semigroup.semigroupArray)));
var secondaryC = "secondary";
var runRenderM = function (f) {
    return function (r) {
        var v = Control_Monad_Reader.runReader(r)(f);
        var attrs = (function () {
            if (f instanceof Focused && f.value0.locked) {
                return [ Halogen_HTML_Properties.class_("locked") ];
            };
            return [ Halogen_HTML_Properties.class_("unlocked") ];
        })();
        return {
            ast: Halogen_HTML_Elements.pre(attrs)([ Halogen_HTML_Elements.code_(Data_Semigroup.append(Data_Semigroup.semigroupArray)(v.doc.before.html)(v.doc.here.html)) ]),
            summary: (function () {
                if (v.doc.here.match instanceof NoMatch) {
                    return [  ];
                };
                if (v.doc.here.match instanceof Match) {
                    return Data_Array.reverse(Data_Array.fromFoldable(Data_List_Types.foldableList)(v.doc.here.match.value1));
                };
                throw new Error("Failed pattern match at Haskell.Render (line 172, column 15 - line 174, column 50): " + [ v.doc.here.match.constructor.name ]);
            })()
        };
    };
};
var rendersRenders = new Renders(function (x) {
    return x;
});
var rendersMaybe = function (v) {
    return function (v1) {
        if (v1 instanceof Data_Maybe.Nothing) {
            return Control_Applicative.pure(Control_Monad_Reader_Trans.applicativeReaderT(Data_Identity.applicativeIdentity))([  ]);
        };
        if (v1 instanceof Data_Maybe.Just) {
            return Data_Functor.map(Control_Monad_Reader_Trans.functorReaderT(Data_Identity.functorIdentity))(Data_Array.singleton)(v(v1.value0));
        };
        throw new Error("Failed pattern match at Haskell.Render (line 1218, column 1 - line 1218, column 81): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var rendersAppend$prime = Data_Semigroup.append(Control_Monad_Reader_Trans.semigroupReaderT(Data_Identity.applyIdentity)(Data_Semigroup.semigroupArray));
var renders = function (dict) {
    return dict.renders;
};
var rendersAppend = function (dictRenders) {
    return function (xs) {
        return function (ys) {
            return rendersAppend$prime(xs)(renders(dictRenders)(ys));
        };
    };
};
var rendersMaybe_ = function (dictRenders) {
    return function (v) {
        if (v instanceof Data_Maybe.Nothing) {
            return Control_Applicative.pure(Control_Monad_Reader_Trans.applicativeReaderT(Data_Identity.applicativeIdentity))([  ]);
        };
        if (v instanceof Data_Maybe.Just) {
            return renders(dictRenders)(v.value0);
        };
        throw new Error("Failed pattern match at Haskell.Render (line 1222, column 1 - line 1223, column 34): " + [ v.constructor.name ]);
    };
};
var renderSnocMaybe$prime = function (xs) {
    return function (v) {
        if (v instanceof Data_Maybe.Just) {
            return Data_Semigroup.append(Control_Monad_Reader_Trans.semigroupReaderT(Data_Identity.applyIdentity)(Data_Semigroup.semigroupArray))(xs)(v.value0);
        };
        if (v instanceof Data_Maybe.Nothing) {
            return xs;
        };
        throw new Error("Failed pattern match at Haskell.Render (line 352, column 1 - line 353, column 79): " + [ xs.constructor.name, v.constructor.name ]);
    };
};
var renderSnoc$prime = function (xs) {
    return function (x) {
        return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(xs)(function (ys) {
            return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(x)(function (y) {
                return Control_Applicative.pure(Control_Monad_Reader_Trans.applicativeReaderT(Data_Identity.applicativeIdentity))(Data_Semigroup.append(Data_Semigroup.semigroupArray)(ys)([ y ]));
            });
        });
    };
};
var renderRender = new Render(function (x) {
    return x;
});
var renderLink = function (v) {
    return Halogen_HTML_Elements.div_([ Halogen_HTML_Core.text("Hakell 2010: "), Halogen_HTML_Elements.a([ Halogen_HTML_Properties.href(v.value1) ])([ Halogen_HTML_Core.text(v.value0) ]) ]);
};
var render = function (dict) {
    return dict.render;
};
var renderSnoc = function (dictRender) {
    return function (xs) {
        return function (x) {
            return renderSnoc$prime(xs)(render(dictRender)(x));
        };
    };
};
var renderTwo = function (dictRender) {
    return function (dictRender1) {
        return function (x) {
            return function (y) {
                return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(render(dictRender)(x))(function (x$prime) {
                    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(render(dictRender1)(y))(function (y$prime) {
                        return Control_Applicative.pure(Control_Monad_Reader_Trans.applicativeReaderT(Data_Identity.applicativeIdentity))([ x$prime, y$prime ]);
                    });
                });
            };
        };
    };
};
var rendersTuple = function (dictRender) {
    return function (dictRender1) {
        return new Renders(function (v) {
            return renderTwo(dictRender)(dictRender1)(v.value0)(v.value1);
        });
    };
};
var renderTwo$prime = function (dictRender) {
    return function (x) {
        return function (y) {
            return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(render(dictRender)(x))(function (x$prime) {
                return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(y)(function (y$prime) {
                    return Control_Applicative.pure(Control_Monad_Reader_Trans.applicativeReaderT(Data_Identity.applicativeIdentity))([ x$prime, y$prime ]);
                });
            });
        };
    };
};
var rendersFoldable = function (dictRender) {
    return function (dictFoldable) {
        return Data_Foldable.foldMap(dictFoldable)(Control_Monad_Reader_Trans.monoidReaderT(Data_Identity.applicativeIdentity)(Data_Monoid.monoidArray))((function () {
            var $610 = Data_Functor.map(Control_Monad_Reader_Trans.functorReaderT(Data_Identity.functorIdentity))(Data_Array.singleton);
            var $611 = render(dictRender);
            return function ($612) {
                return $610($611($612));
            };
        })());
    };
};
var rendersArray = function (dictRender) {
    return new Renders(rendersFoldable(dictRender)(Data_Foldable.foldableArray));
};
var rendersList = function (dictRender) {
    return new Renders(rendersFoldable(dictRender)(Data_List_Types.foldableList));
};
var rendersNonEmptyArray = function (dictRender) {
    return new Renders(rendersFoldable(dictRender)(Data_Array_NonEmpty_Internal.foldableNonEmptyArray));
};
var rendersMaybe$prime = function (dictRender) {
    return new Renders(rendersMaybe(render(dictRender)));
};
var rendersNonEmpty = function (dictRender) {
    return function (dictRenders) {
        return new Renders(function (v) {
            return Control_Apply.lift2(Control_Monad_Reader_Trans.applyReaderT(Data_Identity.applyIdentity))(Data_Array.cons)(render(dictRender)(v.value0))(renders(dictRenders)(v.value1));
        });
    };
};
var qC = Halogen_HTML_Properties.class_("quantifier");
var showQuantifier = function (v) {
    if (v instanceof Opt01) {
        return Halogen_HTML_Elements.sup([ qC, Halogen_HTML_Properties.title("zero or one") ])([ Halogen_HTML_Core.text("?") ]);
    };
    if (v instanceof Star) {
        return Halogen_HTML_Elements.sup([ qC, Halogen_HTML_Properties.title("zero or more") ])([ Halogen_HTML_Core.text("*") ]);
    };
    if (v instanceof Plus) {
        return Halogen_HTML_Elements.sup([ qC, Halogen_HTML_Properties.title("one or more") ])([ Halogen_HTML_Core.text("+") ]);
    };
    throw new Error("Failed pattern match at Haskell.Render (line 233, column 18 - line 236, column 58): " + [ v.constructor.name ]);
};
var renderRule_ = function (v) {
    if (v instanceof T) {
        return Halogen_HTML_Elements.span([ Halogen_HTML_Properties.class_(srClass("terminal")) ])([ Halogen_HTML_Core.text(v.value0) ]);
    };
    if (v instanceof N) {
        return Halogen_HTML_Elements.span([ Halogen_HTML_Properties.class_(srClass("nonterminal")) ])([ Halogen_HTML_Core.text(v.value0) ]);
    };
    if (v instanceof K) {
        return Halogen_HTML_Elements.span([ Halogen_HTML_Properties.class_(srClass("keyword")) ])([ Halogen_HTML_Core.text(v.value0) ]);
    };
    if (v instanceof Grp) {
        return Halogen_HTML_Elements.span_([ Halogen_HTML_Elements.span([ Halogen_HTML_Properties.class_("grp") ])(Data_Array.intersperse(Halogen_HTML_Core.text(" "))(Data_Functor.map(Data_Functor.functorArray)(renderRule_)(v.value1))), showQuantifier(v.value0) ]);
    };
    throw new Error("Failed pattern match at Haskell.Render (line 223, column 1 - line 223, column 28): " + [ v.constructor.name ]);
};
var renderRule = function (v) {
    return Halogen_HTML_Elements.div_(Data_Array.singleton(Halogen_HTML_Elements.code_([ Halogen_HTML_Elements.span_([ Halogen_HTML_Core.text(v.value0) ]), Halogen_HTML_Elements.span_([ Halogen_HTML_Core.text(" \u2192 ") ]), Halogen_HTML_Elements.span_(Data_Array.intersperse(Halogen_HTML_Core.text(" "))(Data_Functor.map(Data_Functor.functorArray)(renderRule_)(v.value1))) ])));
};
var renderDescr = function (v) {
    if (v instanceof Syntax) {
        return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("syntax-rules") ])([ Halogen_HTML_Core.text("General syntax:"), Halogen_HTML_Elements.div_(Data_Functor.map(Data_Functor.functorArray)(renderRule)(v.value0)) ]);
    };
    if (v instanceof Links) {
        return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("links") ])(Data_Functor.map(Data_Functor.functorArray)(renderLink)(v.value0));
    };
    throw new Error("Failed pattern match at Haskell.Render (line 199, column 15 - line 207, column 26): " + [ v.constructor.name ]);
};
var prettySpace = Halogen_HTML_Elements.span([ Halogen_HTML_Properties.class_("space") ])([ Halogen_HTML_Core.text(" ") ]);
var positionLT = function (v) {
    return function (v1) {
        return Data_Ord.lessThan(Data_Tuple.ordTuple(Data_Ord.ordInt)(Data_Ord.ordInt))(new Data_Tuple.Tuple(v.line, v.column))(new Data_Tuple.Tuple(v1.line, v1.column));
    };
};
var newtypeAhead = new Data_Newtype.Newtype(function () {
    return undefined;
});
var newtypeADoc = new Data_Newtype.Newtype(function () {
    return undefined;
});
var monoidMatch = new Data_Monoid.Monoid(function () {
    return semigroupMatch;
}, NoMatch.value);
var monoidAhead = function (dictMonoid) {
    return new Data_Monoid.Monoid(function () {
        return semigroupAhead(dictMonoid.Semigroup0());
    }, {
        before: Data_Monoid.mempty(dictMonoid),
        here: Data_Monoid.mempty(dictMonoid)
    });
};
var monoidADoc = monoidAhead(Data_Monoid.monoidRecord()(Data_Monoid.monoidRecordCons(new Data_Symbol.IsSymbol(function () {
    return "html";
}))(Data_Monoid.monoidArray)()(Data_Monoid.monoidRecordCons(new Data_Symbol.IsSymbol(function () {
    return "match";
}))(monoidMatch)()(Data_Monoid.monoidRecordNil))));
var matchingADoc = function (v) {
    if (v.here.match instanceof NoMatch) {
        return false;
    };
    if (v.here.match instanceof Match) {
        return true;
    };
    throw new Error("Failed pattern match at Haskell.Render (line 262, column 52 - line 264, column 20): " + [ v.here.match.constructor.name ]);
};
var matchToken = function (t) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(Control_Monad_Reader_Class.ask(Control_Monad_Reader_Trans.monadAskReaderT(Data_Identity.monadIdentity)))(function (f) {
        if (f instanceof Focused && f.value0.elt instanceof Data_Either.Left) {
            return Control_Applicative.pure(Control_Monad_Reader_Trans.applicativeReaderT(Data_Identity.applicativeIdentity))(Haskell_Token.eqToken(f.value0.elt.value0)(t));
        };
        return Control_Applicative.pure(Control_Monad_Reader_Trans.applicativeReaderT(Data_Identity.applicativeIdentity))(false);
    });
};
var match0 = new Match(0, Data_List_Types.Nil.value);
var levelC = function (i) {
    return "level-" + Data_Show.show(Data_Show.showInt)(i);
};
var isSpecial = function (v) {
    if (v instanceof Haskell_Token.Keyword) {
        return true;
    };
    if (v instanceof Haskell_Token.Special) {
        return true;
    };
    if (v instanceof Haskell_Token.PseudoKeyword) {
        return true;
    };
    return false;
};
var syntaxNode = function (v) {
    if (v.tag instanceof NodeToken) {
        if (isSpecial(v.tag.value0.tag)) {
            return Halogen_HTML_Elements.span([ Halogen_HTML_Properties.classes([ "token", srClass("keyword") ]) ])([ Halogen_HTML_Core.text(v.tag.value0.value) ]);
        };
        if (Data_Boolean.otherwise) {
            return Halogen_HTML_Elements.span([ Halogen_HTML_Properties.class_("token") ])([ Halogen_HTML_Core.text(v.tag.value0.value) ]);
        };
    };
    if (v.tag instanceof NodeTag) {
        var cs0 = [ "nonterminal", srClass("nonterminal") ];
        var cs = (function () {
            if (matchingADoc(v.doc)) {
                return [ Halogen_HTML_Properties.classes(Data_Semigroup.append(Data_Semigroup.semigroupArray)(cs0)([ "under-hlnode" ])) ];
            };
            if (Data_Boolean.otherwise) {
                return [ Halogen_HTML_Properties.classes(cs0) ];
            };
            throw new Error("Failed pattern match at Haskell.Render (line 257, column 9 - line 258, column 42): " + [  ]);
        })();
        return Halogen_HTML_Elements.span(cs)([ Halogen_HTML_Core.text(v.tag.value0) ]);
    };
    throw new Error("Failed pattern match at Haskell.Render (line 251, column 23 - line 259, column 25): " + [ v.tag.constructor.name ]);
};
var matchItem = function (cs) {
    return function (j) {
        return function (tag) {
            return function (v) {
                return function (nodes) {
                    var summ = Halogen_HTML_Elements.summary_([ Halogen_HTML_Elements.span_([ Halogen_HTML_Core.text(v.name) ]), Halogen_HTML_Core.text(" "), Halogen_HTML_Elements.span_([ Halogen_HTML_Core.text("("), (function () {
                        if (tag instanceof NodeToken) {
                            return Halogen_HTML_Core.text("token");
                        };
                        if (tag instanceof NodeTag) {
                            return Halogen_HTML_Elements.code([ Halogen_HTML_Properties.class_(srClass("nonterminal")) ])([ Halogen_HTML_Core.text(tag.value0) ]);
                        };
                        throw new Error("Failed pattern match at Haskell.Render (line 188, column 13 - line 190, column 83): " + [ tag.constructor.name ]);
                    })(), Halogen_HTML_Core.text(")") ]), Halogen_HTML_Elements.span_([ Halogen_HTML_Elements.code([ Halogen_HTML_Properties.classes(cs) ])(Data_Array.intersperse(prettySpace)(Data_Functor.map(Data_Functor.functorArray)(syntaxNode)(nodes))) ]) ]);
                    var info__ = (function () {
                        var v1 = function (v2) {
                            if (Data_Boolean.otherwise) {
                                return Data_Functor.map(Data_Functor.functorArray)(renderDescr)(v.descr);
                            };
                            throw new Error("Failed pattern match at Haskell.Render (line 177, column 1 - line 177, column 83): " + [  ]);
                        };
                        if (v.descr.length === 0) {
                            return [  ];
                        };
                        return v1(true);
                    })();
                    return Halogen_HTML_Elements.div([ Halogen_HTML_Events.onMouseEnter(function (v1) {
                        return new NodeHover(j);
                    }), Halogen_HTML_Events.onMouseLeave(function (v1) {
                        return NodeUnhover.value;
                    }), Halogen_HTML_Properties.classes(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ "syntax-desc" ])(cs)) ])([ Halogen_HTML_Elements.details_(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ summ ])(info__)) ]);
                };
            };
        };
    };
};
var node = function (tag) {
    return function (z) {
        return function (xs) {
            var hlnodeC = function (v) {
                return function (v1) {
                    if (v instanceof Focused && v.value0.node instanceof Data_Maybe.Just) {
                        if (v.value0.node.value0 === v1) {
                            return [ "hlnode" ];
                        };
                        if (v.value0.node.value0 > v1) {
                            return [ "under-hlnode" ];
                        };
                    };
                    return [  ];
                };
            };
            var mkNode = function (f) {
                return function (s) {
                    var v = (function () {
                        if (s.here.match instanceof NoMatch) {
                            return {
                                match: NoMatch.value,
                                attrs: [  ]
                            };
                        };
                        if (s.here.match instanceof Match) {
                            var i = s.here.match.value0 + 1 | 0;
                            var hlnodeC_ = hlnodeC(f)(i);
                            return {
                                match: new Match(i, new Data_List_Types.Cons(matchItem(hlnodeC_)(i)(tag)(z)(xs), s.here.match.value1)),
                                attrs: [ Halogen_HTML_Properties.classes(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ levelC(i) ])(hlnodeC_)) ]
                            };
                        };
                        throw new Error("Failed pattern match at Haskell.Render (line 288, column 30 - line 294, column 64): " + [ s.here.match.constructor.name ]);
                    })();
                    return {
                        here: {
                            html: [ Halogen_HTML_Elements.span(v.attrs)(s.here.html) ],
                            match: v.match
                        },
                        before: s.before
                    };
                };
            };
            return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(Control_Monad_Reader_Class.ask(Control_Monad_Reader_Trans.monadAskReaderT(Data_Identity.monadIdentity)))(function (f) {
                var x = Data_Foldable.foldMap(Data_Foldable.foldableArray)(monoidADoc)(function (v) {
                    return v.doc;
                })(xs);
                return Control_Applicative.pure(Control_Monad_Reader_Trans.applicativeReaderT(Data_Identity.applicativeIdentity))({
                    doc: Data_Newtype.over()()(ADoc)(Data_Newtype.over()()(Ahead)(mkNode(f)))(x),
                    tag: tag
                });
            });
        };
    };
};
var renderWith = function (dictRenders) {
    return function (tag) {
        return function (z) {
            return function (x) {
                return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renders(dictRenders)(x))(node(tag)(z));
            };
        };
    };
};
var infotagC = function (v) {
    return "tooltip-extensionused";
};
var info_ = function (v) {
    if (v.tag instanceof Haskell_Token.Ident) {
        return Halogen_HTML_Elements.div_([ Halogen_HTML_Elements.p_([ Halogen_HTML_Core.text("Identifier: "), Halogen_HTML_Elements.code_([ Halogen_HTML_Core.text(v.value) ]) ]) ]);
    };
    if (v.tag instanceof Haskell_Token.Keyword) {
        return Halogen_HTML_Elements.div_([ Halogen_HTML_Elements.p_([ Halogen_HTML_Core.text("Keyword: "), Halogen_HTML_Elements.code_([ Halogen_HTML_Core.text(v.value) ]) ]) ]);
    };
    if (v.tag instanceof Haskell_Token.PseudoKeyword) {
        return Halogen_HTML_Elements.div_([ Halogen_HTML_Elements.p_([ Halogen_HTML_Core.text("Pseudo-keyword: "), Halogen_HTML_Elements.code_([ Halogen_HTML_Core.text(v.value) ]) ]), Halogen_HTML_Elements.p_([ Halogen_HTML_Core.text("A pseudo-keyword is not reserved, so it can be used as an identifer, but serves as a keyword in certain contexts.") ]) ]);
    };
    if (v.tag instanceof Haskell_Token.Special && !v.tag.value0) {
        return Halogen_HTML_Elements.div_([ Halogen_HTML_Elements.p_([ Halogen_HTML_Core.text("Special symbol: "), Halogen_HTML_Elements.code_([ Halogen_HTML_Core.text("'" + (v.value + "'")) ]) ]) ]);
    };
    if (v.tag instanceof Haskell_Token.Special && v.tag.value0) {
        return Halogen_HTML_Elements.div_([ Halogen_HTML_Elements.p_([ Halogen_HTML_Core.text("Implicit layout symbol: "), Halogen_HTML_Elements.code_([ Halogen_HTML_Core.text("'" + (v.value + "'")) ]) ]), Halogen_HTML_Elements.p_([ Halogen_HTML_Core.text("This symbol is inserted by the layout rules.") ]) ]);
    };
    if (v.tag instanceof Haskell_Token.ModId) {
        return Halogen_HTML_Elements.div_([ Halogen_HTML_Core.text("Module identifier") ]);
    };
    if (v.tag instanceof Haskell_Token.LitInteger) {
        return Halogen_HTML_Elements.div_([ Halogen_HTML_Core.text("Integer literal") ]);
    };
    if (v.tag instanceof Haskell_Token.LitFloat) {
        return Halogen_HTML_Elements.div_([ Halogen_HTML_Core.text("Floating point literal") ]);
    };
    if (v.tag instanceof Haskell_Token.LitChar) {
        return Halogen_HTML_Elements.div_([ Halogen_HTML_Core.text("Char literal") ]);
    };
    if (v.tag instanceof Haskell_Token.LitString) {
        return Halogen_HTML_Elements.div_([ Halogen_HTML_Core.text("String literal") ]);
    };
    if (v.tag instanceof Haskell_Token.Eof) {
        return Halogen_HTML_Core.text("End of file");
    };
    throw new Error("Failed pattern match at Haskell.Render (line 40, column 19 - line 60, column 30): " + [ v.tag.constructor.name ]);
};
var info = function (v) {
    if (v instanceof Idle) {
        return Halogen_HTML_Core.text("");
    };
    if (v instanceof Focused) {
        if (v.value0.elt instanceof Data_Either.Left) {
            return info_(v.value0.elt.value0);
        };
        if (v.value0.elt instanceof Data_Either.Right) {
            return Halogen_HTML_Core.text("");
        };
        throw new Error("Failed pattern match at Haskell.Render (line 35, column 26 - line 37, column 23): " + [ v.value0.elt.constructor.name ]);
    };
    throw new Error("Failed pattern match at Haskell.Render (line 33, column 1 - line 33, column 38): " + [ v.constructor.name ]);
};
var incMatch = function (v) {
    if (v instanceof NoMatch) {
        return NoMatch.value;
    };
    if (v instanceof Match) {
        return new Match(v.value0 + 1 | 0, v.value1);
    };
    throw new Error("Failed pattern match at Haskell.Render (line 161, column 1 - line 161, column 27): " + [ v.constructor.name ]);
};
var incMatchOf = Data_Newtype.over()()(ADoc)(Data_Newtype.over()()(Ahead)(function (d) {
    return {
        here: {
            match: incMatch(d.here.match),
            html: d.here.html
        },
        before: d.before
    };
}));
var headerSyntax = new Syntax([ new SyntaxRule("header", [ new K("module"), new T("modid"), new Grp(Opt01.value, [ new N("exports") ]), new K("where") ]) ]);
var ghostData = Halogen_HTML_Properties.attr("data-ghost");
var ghostC = "ghost";
var focusedC = "focused";
var eqToken$prime = function (v) {
    return function (v1) {
        if (v instanceof Data_Either.Left && v1 instanceof Data_Either.Left) {
            return Haskell_Token.eqToken(v.value0)(v1.value0);
        };
        if (v instanceof Data_Either.Right && v1 instanceof Data_Either.Right) {
            return Data_Eq.eq(Haskell_Token.eqSubtoken)(v.value0)(v1.value0);
        };
        return false;
    };
};
var handleAction = function (v) {
    if (v instanceof Hover) {
        return function (v1) {
            if (v1 instanceof Focused && v1.value0.locked) {
                return Data_Maybe.Nothing.value;
            };
            return new Data_Maybe.Just(new Focused({
                elt: v.value0,
                locked: false,
                node: Data_Maybe.Nothing.value
            }));
        };
    };
    if (v instanceof Unhover) {
        return function (v1) {
            if (v1 instanceof Focused && v1.value0.locked) {
                return Data_Maybe.Nothing.value;
            };
            return new Data_Maybe.Just(Idle.value);
        };
    };
    if (v instanceof Click) {
        return function (v1) {
            var v2 = function (v3) {
                return new Data_Maybe.Just(new Focused({
                    elt: v.value0,
                    locked: true,
                    node: Data_Maybe.Nothing.value
                }));
            };
            if (v1 instanceof Focused) {
                if (v1.value0.locked) {
                    var $388 = eqToken$prime(v1.value0.elt)(v.value0);
                    if ($388) {
                        return new Data_Maybe.Just(new Focused({
                            elt: v.value0,
                            locked: false,
                            node: Data_Maybe.Nothing.value
                        }));
                    };
                    return v2(true);
                };
                return v2(true);
            };
            return v2(true);
        };
    };
    if (v instanceof NodeUnhover) {
        return function (v1) {
            if (v1 instanceof Focused) {
                return new Data_Maybe.Just(new Focused({
                    elt: v1.value0.elt,
                    locked: v1.value0.locked,
                    node: Data_Maybe.Nothing.value
                }));
            };
            return Data_Maybe.Nothing.value;
        };
    };
    if (v instanceof NodeHover) {
        return function (v1) {
            if (v1 instanceof Focused) {
                return new Data_Maybe.Just(new Focused({
                    elt: v1.value0.elt,
                    locked: v1.value0.locked,
                    node: new Data_Maybe.Just(v.value0)
                }));
            };
            return Data_Maybe.Nothing.value;
        };
    };
    throw new Error("Failed pattern match at Haskell.Render (line 143, column 16 - line 159, column 17): " + [ v.constructor.name ]);
};
var renderToken_ = function (f) {
    return function (v) {
        var v1 = (function () {
            if (f instanceof Focused && eqToken$prime(f.value0.elt)(new Data_Either.Left(v))) {
                return {
                    match: match0,
                    cs: [ tagC(v.tag), tokenC, focusedC, levelC(0) ]
                };
            };
            var cs = [ tagC(v.tag), tokenC ];
            return {
                match: NoMatch.value,
                cs: cs
            };
        })();
        var attrs = function (x) {
            return [ Halogen_HTML_Properties.classes(Data_Semigroup.append(Data_Semigroup.semigroupArray)(v1.cs)(x)), Halogen_HTML_Events.onMouseEnter(function (v2) {
                return new Hover(new Data_Either.Left(v));
            }), Halogen_HTML_Events.onMouseLeave(function (v2) {
                return new Unhover(new Data_Either.Left(v));
            }), Halogen_HTML_Events.onClick(function (v2) {
                return new Click(new Data_Either.Left(v));
            }) ];
        };
        var html = (function () {
            if (v.tag instanceof Haskell_Token.Special && v.tag.value0) {
                return [ Halogen_HTML_Elements.span(Data_Semigroup.append(Data_Semigroup.semigroupArray)(attrs([ ghostC ]))([ ghostData(v.value) ]))([  ]) ];
            };
            return [ Halogen_HTML_Elements.span(attrs([  ]))([ Halogen_HTML_Core.text(v.value) ]) ];
        })();
        return {
            html: html,
            match: v1.match
        };
    };
};
var constrSyntax = new Syntax([ new SyntaxRule("constr", [ new T("con"), new Grp(Star.value, [ new N("bangtype") ]) ]), new SyntaxRule("constr", [ new N("bangtype"), new T("conop"), new N("bangtype") ]), new SyntaxRule("constr", [ new T("con"), new K("{"), new N("fielddecls"), new K("}") ]), new SyntaxRule("bangtype", [ new K("!"), new N("type") ]), new SyntaxRule("bangtype", [ new N("type") ]) ]);
var classes = Safe_Coerce.coerce()(Halogen_HTML_Properties.classes);
var renderInfo = function (i0) {
    return function (v) {
        var infoElem = function (v1) {
            return [ Halogen_HTML_Elements.span([ classes([ "tooltip", infotagC(v1.tag) ]) ])([ Halogen_HTML_Elements.span([ classes([ "tooltip-contents" ]) ])([ Halogen_HTML_Core.text(v1.msg) ]) ]) ];
        };
        var go = function (y) {
            return {
                before: {
                    html: Data_Semigroup.append(Data_Semigroup.semigroupArray)(y.before.html)(infoElem(i0)),
                    match: y.before.match
                },
                here: y.here
            };
        };
        return {
            tag: v.tag,
            doc: Data_Newtype.over()()(ADoc)(Data_Newtype.over()()(Ahead)(go))(v.doc)
        };
    };
};
var bolC = "begin-line";
var renderSubtoken = function (v) {
    if (v.value === "\x0a") {
        return Halogen_HTML_Core.text("\x0a");
    };
    if (Data_Boolean.otherwise) {
        var cs = Halogen_HTML_Properties.classes((function () {
            if (v.tag instanceof Haskell_Token.Spaces && Haskell_Token.columnOf(v.position) === 0) {
                return [ bolC ];
            };
            return [ spaceC ];
        })());
        var attrs = [ cs, Halogen_HTML_Events.onMouseEnter(function (v1) {
            return new Hover(new Data_Either.Right(v));
        }), Halogen_HTML_Events.onMouseLeave(function (v1) {
            return new Unhover(new Data_Either.Right(v));
        }) ];
        return Halogen_HTML_Elements.span(attrs)([ Halogen_HTML_Core.text(v.value) ]);
    };
    throw new Error("Failed pattern match at Haskell.Render (line 1262, column 1 - line 1262, column 36): " + [ v.constructor.name ]);
};
var renderSubtokens = function (f) {
    return function (v) {
        return {
            html: Data_Functor.map(Data_Functor.functorArray)(renderSubtoken)(v),
            match: (function () {
                if (f instanceof Focused && (f.value0.elt instanceof Data_Either.Right && Data_Foldable.elem(Data_Foldable.foldableArray)(Haskell_Token.eqSubtoken)(f.value0.elt.value0)(v))) {
                    return match0;
                };
                return NoMatch.value;
            })()
        };
    };
};
var renderToken0 = function (v) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(Control_Monad_Reader_Class.ask(Control_Monad_Reader_Trans.monadAskReaderT(Data_Identity.monadIdentity)))(function (f) {
        var here = renderToken_(f)(v);
        var before = renderSubtokens(f)(v.before);
        return Control_Applicative.pure(Control_Monad_Reader_Trans.applicativeReaderT(Data_Identity.applicativeIdentity))(ADoc({
            before: before,
            here: here
        }));
    });
};
var renderToken = new Render(function (t0) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renderToken0(t0))(function (doc) {
        return Control_Applicative.pure(Control_Monad_Reader_Trans.applicativeReaderT(Data_Identity.applicativeIdentity))({
            tag: new NodeToken(t0),
            doc: doc
        });
    });
});
var renderC = new Render(function (v) {
    if (v instanceof Haskell_AST.IdId) {
        var z = {
            name: "C",
            descr: [  ]
        };
        return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(render(renderToken)(v.value0))((function () {
            var $613 = node(new NodeTag("conid"))(z);
            return function ($614) {
                return $613(Data_Array.singleton($614));
            };
        })());
    };
    if (v instanceof Haskell_AST.IdSym) {
        var z = {
            name: "CSym",
            descr: [  ]
        };
        return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renderSnoc(renderToken)(renderTwo(renderToken)(renderToken)(v.value0.lp_)(v.value0.sym))(v.value0.rp_))(node(new NodeTag("conid"))(z));
    };
    throw new Error("Failed pattern match at Haskell.Render (line 1145, column 1 - line 1156, column 23): " + [ v.constructor.name ]);
});
var renderCOp = new Render(function (v) {
    if (v instanceof Haskell_AST.OpSym) {
        var z = {
            name: "conopsym",
            descr: [  ]
        };
        return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(render(renderToken)(v.value0))((function () {
            var $615 = node(new NodeTag("conop"))(z);
            return function ($616) {
                return $615(Data_Array.singleton($616));
            };
        })());
    };
    if (v instanceof Haskell_AST.OpId) {
        var z = {
            name: "conopid",
            descr: [  ]
        };
        return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renderSnoc(renderToken)(renderTwo(renderToken)(renderToken)(v.value0.lbt_)(v.value0.ident))(v.value0.rbt_))(node(new NodeTag("conop"))(z));
    };
    throw new Error("Failed pattern match at Haskell.Render (line 1170, column 1 - line 1180, column 23): " + [ v.constructor.name ]);
});
var renderGCon = new Render(function (c0) {
    return Control_Bind.bindFlipped(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(node(new NodeTag("gcon"))(summary(summaryGCon)(c0)))((function () {
        if (c0 instanceof Haskell_AST.Unit) {
            return renderTwo(renderToken)(renderToken)(c0.value0.lp_)(c0.value0.rp_);
        };
        if (c0 instanceof Haskell_AST.Nil) {
            return renderTwo(renderToken)(renderToken)(c0.value0.lb_)(c0.value0.rb_);
        };
        if (c0 instanceof Haskell_AST.TupleCon) {
            return renderSnoc(renderToken)(rendersAppend(rendersArray(renderToken))(renderTwo(renderToken)(renderToken)(c0.value0.lp_)(c0.value0.comma_))(c0.value0.commas_))(c0.value0.rp_);
        };
        if (c0 instanceof Haskell_AST.Con) {
            return Data_Functor.map(Control_Monad_Reader_Trans.functorReaderT(Data_Identity.functorIdentity))(Data_Array.singleton)(render(renderC)(c0.value0));
        };
        throw new Error("Failed pattern match at Haskell.Render (line 474, column 54 - line 478, column 38): " + [ c0.constructor.name ]);
    })());
});
var renderLiteral = new Render(function (v) {
    return render(renderToken)(v);
});
var renderOp = new Render(function (v) {
    if (v instanceof Haskell_AST.OpSym) {
        var z = {
            name: "varopsym",
            descr: [  ]
        };
        return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(render(renderToken)(v.value0))((function () {
            var $617 = node(new NodeTag("op"))(z);
            return function ($618) {
                return $617(Data_Array.singleton($618));
            };
        })());
    };
    if (v instanceof Haskell_AST.OpId) {
        var z = {
            name: "varopid",
            descr: [  ]
        };
        return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renderSnoc(renderToken)(renderTwo(renderToken)(renderToken)(v.value0.lbt_)(v.value0.ident))(v.value0.rbt_))(node(new NodeTag("op"))(z));
    };
    throw new Error("Failed pattern match at Haskell.Render (line 1185, column 1 - line 1195, column 23): " + [ v.constructor.name ]);
});
var renderVOp = new Render(function (v) {
    return render(renderOp)(v);
});
var renderTyV = new Render(function (v) {
    return render(renderToken)(v);
});
var renderV = new Render(function (v) {
    if (v instanceof Haskell_AST.IdId) {
        var z = {
            name: "varid",
            descr: [  ]
        };
        return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(render(renderToken)(v.value0))((function () {
            var $619 = node(new NodeTag("var"))(z);
            return function ($620) {
                return $619(Data_Array.singleton($620));
            };
        })());
    };
    if (v instanceof Haskell_AST.IdSym) {
        var z = {
            name: "varsym",
            descr: [  ]
        };
        return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renderSnoc(renderToken)(renderTwo(renderToken)(renderToken)(v.value0.lp_)(v.value0.sym))(v.value0.rp_))(node(new NodeTag("var"))(z));
    };
    throw new Error("Failed pattern match at Haskell.Render (line 1158, column 1 - line 1168, column 23): " + [ v.constructor.name ]);
});
var renderField = function (dictRender) {
    return new Render(function (v) {
        return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renderSnoc(dictRender)(renderTwo(renderV)(renderToken)(v.field)(v.eq_))(v.rhs))(node(new NodeTag("field"))({
            name: "field binding",
            descr: [  ]
        }));
    });
};
var renderImportItem = new Render(function (v) {
    if (v instanceof Haskell_AST.ImportItemVar) {
        return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(render(renderV)(v.value0))((function () {
            var $621 = node(new NodeTag("cname"))({
                name: "value member",
                descr: [  ]
            });
            return function ($622) {
                return $621(Data_Array.singleton($622));
            };
        })());
    };
    if (v instanceof Haskell_AST.ImportItemCon) {
        return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(render(renderC)(v.value0))((function () {
            var $623 = node(new NodeTag("cname"))({
                name: "constructor member",
                descr: [  ]
            });
            return function ($624) {
                return $623(Data_Array.singleton($624));
            };
        })());
    };
    throw new Error("Failed pattern match at Haskell.Render (line 747, column 1 - line 757, column 22): " + [ v.constructor.name ]);
});
var rendersGTyCon = new Renders(function (v) {
    if (v instanceof Haskell_AST.TyArrowCon) {
        return renderSnoc(renderToken)(renderTwo(renderToken)(renderToken)(v.value0.lp_)(v.value0.arr_))(v.value0.rp_);
    };
    if (v instanceof Haskell_AST.TyUnit) {
        return renderTwo(renderToken)(renderToken)(v.value0.lp_)(v.value0.rp_);
    };
    if (v instanceof Haskell_AST.TyNil) {
        return renderTwo(renderToken)(renderToken)(v.value0.lb_)(v.value0.rb_);
    };
    if (v instanceof Haskell_AST.TyTupleCon) {
        return renderSnoc(renderToken)(rendersAppend(rendersArray(renderToken))(renderTwo(renderToken)(renderToken)(v.value0.lp_)(v.value0.comma_))(v.value0.commas_))(v.value0.rp_);
    };
    if (v instanceof Haskell_AST.TyCon) {
        return Data_Functor.map(Control_Monad_Reader_Trans.functorReaderT(Data_Identity.functorIdentity))(Data_Array.singleton)(render(renderC)(v.value0));
    };
    throw new Error("Failed pattern match at Haskell.Render (line 617, column 13 - line 622, column 40): " + [ v.constructor.name ]);
});
var rendersParens = function (dictRenders) {
    return new Renders(function (v) {
        return renderSnoc(renderToken)(Control_Apply.lift2(Control_Monad_Reader_Trans.applyReaderT(Data_Identity.applyIdentity))(Data_Array.cons)(render(renderToken)(v.lp_))(renders(dictRenders)(v.value)))(v.rp_);
    });
};
var rendersSepList = function (f) {
    return function (v) {
        if (v instanceof Haskell_AST.SepNil) {
            return Data_Monoid.mempty(Control_Monad_Reader_Trans.monoidReaderT(Data_Identity.applicativeIdentity)(Data_Monoid.monoidArray));
        };
        if (v instanceof Haskell_AST.SepCons) {
            return rendersAppend(rendersRenders)(rendersAppend(rendersMaybe$prime(renderToken))(renderSnoc(renderRender)(Data_Monoid.mempty(Control_Monad_Reader_Trans.monoidReaderT(Data_Identity.applicativeIdentity)(Data_Monoid.monoidArray)))(f(v.value0.head)))(v.value0.sep_))(rendersSepList(f)(v.value0.tail));
        };
        throw new Error("Failed pattern match at Haskell.Render (line 1141, column 20 - line 1143, column 70): " + [ v.constructor.name ]);
    };
};
var rendersSepList$prime = function (dictRender) {
    return new Renders(rendersSepList(render(dictRender)));
};

// TODO: in classes this is only a variable.
var renderPat = new Render(function (p0) {
    return Control_Bind.bindFlipped(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(node(new NodeTag("pat"))(summary(summaryPat)(p0)))((function () {
        if (p0 instanceof Haskell_AST.PVar) {
            return Data_Functor.map(Control_Monad_Reader_Trans.functorReaderT(Data_Identity.functorIdentity))(Data_Array.singleton)(render(renderV)(p0.value0));
        };
        if (p0 instanceof Haskell_AST.PInfix) {
            return renderSnoc(renderPat)(renderTwo(renderPat)(renderCOp)(p0.value0.p1)(p0.value0.op))(p0.value0.p2);
        };
        if (p0 instanceof Haskell_AST.PCon) {
            return Data_Functor.map(Control_Monad_Reader_Trans.functorReaderT(Data_Identity.functorIdentity))(Data_Array.singleton)(render(renderGCon)(p0.value0));
        };
        if (p0 instanceof Haskell_AST.PApp) {
            return rendersAppend(rendersArray(renderPat))(renderSnoc(renderGCon)(Data_Monoid.mempty(Control_Monad_Reader_Trans.monoidReaderT(Data_Identity.applicativeIdentity)(Data_Monoid.monoidArray)))(p0.value0.c))(p0.value0.args);
        };
        if (p0 instanceof Haskell_AST.PLit) {
            return Data_Functor.map(Control_Monad_Reader_Trans.functorReaderT(Data_Identity.functorIdentity))(Data_Array.singleton)(render(renderLiteral)(p0.value0));
        };
        if (p0 instanceof Haskell_AST.PNeg) {
            return renderTwo(renderToken)(renderLiteral)(p0.value0.minus_)(p0.value0.number);
        };
        if (p0 instanceof Haskell_AST.PWild) {
            return Data_Functor.map(Control_Monad_Reader_Trans.functorReaderT(Data_Identity.functorIdentity))(Data_Array.singleton)(render(renderToken)(p0.value0));
        };
        if (p0 instanceof Haskell_AST.PPar) {
            return renderSnoc(renderToken)(renderTwo(renderToken)(renderPat)(p0.value0.lp_)(p0.value0.p))(p0.value0.rp_);
        };
        if (p0 instanceof Haskell_AST.PIrrefutable) {
            return renderTwo(renderToken)(renderPat)(p0.value0.tilde_)(p0.value0.p);
        };
        if (p0 instanceof Haskell_AST.PTuple) {
            return renderSnoc(renderToken)(rendersAppend(rendersSepList$prime(renderPat))(renderSnoc(renderToken)(Data_Monoid.mempty(Control_Monad_Reader_Trans.monoidReaderT(Data_Identity.applicativeIdentity)(Data_Monoid.monoidArray)))(p0.value0.lp_))(p0.value0.ps))(p0.value0.rp_);
        };
        if (p0 instanceof Haskell_AST.PList) {
            return renderSnoc(renderToken)(rendersAppend(rendersSepList$prime(renderPat))(renderSnoc(renderToken)(Data_Monoid.mempty(Control_Monad_Reader_Trans.monoidReaderT(Data_Identity.applicativeIdentity)(Data_Monoid.monoidArray)))(p0.value0.lb_))(p0.value0.ps))(p0.value0.rb_);
        };
        if (p0 instanceof Haskell_AST.PRecord) {
            return renderSnoc(renderToken)(rendersAppend(rendersSepList$prime(renderField(renderPat)))(renderTwo(renderC)(renderToken)(p0.value0.c)(p0.value0.lb_))(p0.value0.fields))(p0.value0.rb_);
        };
        if (p0 instanceof Haskell_AST.PAs) {
            return renderSnoc(renderPat)(renderTwo(renderV)(renderToken)(p0.value0.v)(p0.value0.as_))(p0.value0.p);
        };
        throw new Error("Failed pattern match at Haskell.Render (line 995, column 53 - line 1008, column 32): " + [ p0.constructor.name ]);
    })());
});
var rendersFunLhs = new Renders(function (v) {
    if (v instanceof Haskell_AST.FunLhsVar) {
        return rendersAppend(rendersNonEmptyArray(renderPat))(renderSnoc(renderV)(Data_Monoid.mempty(Control_Monad_Reader_Trans.monoidReaderT(Data_Identity.applicativeIdentity)(Data_Monoid.monoidArray)))(v.value0.v))(v.value0.args);
    };
    if (v instanceof Haskell_AST.FunLhsInfix) {
        return renderSnoc(renderPat)(renderTwo(renderPat)(renderVOp)(v.value0.arg1)(v.value0.op))(v.value0.arg2);
    };
    if (v instanceof Haskell_AST.FunLhsNested) {
        return rendersAppend(rendersNonEmptyArray(renderPat))(renderSnoc(renderToken)(renderTwo(renderToken)(renderFunLhs)(v.value0.lp_)(v.value0.lhs))(v.value0.rp_))(v.value0.args);
    };
    throw new Error("Failed pattern match at Haskell.Render (line 1059, column 1 - line 1062, column 62): " + [ v.constructor.name ]);
});
var renderFunLhs = new Render(function (x) {
    var z = {
        name: "funlhs",
        descr: [  ]
    };
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renders(rendersFunLhs)(x))(node(new NodeTag("funlhs"))(z));
});
var renderLhs_ = function (dictRender) {
    return new Render(function (v) {
        if (v instanceof Haskell_AST.LhsFun) {
            return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renders(rendersFunLhs)(v.value0))(node(new NodeTag("lhs"))({
                name: "function lhs",
                descr: [  ]
            }));
        };
        if (v instanceof Haskell_AST.LhsPat) {
            return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(render(dictRender)(v.value0))((function () {
                var $625 = node(new NodeTag("lhs"))({
                    name: "pattern lhs",
                    descr: [  ]
                });
                return function ($626) {
                    return $625(Data_Array.singleton($626));
                };
            })());
        };
        throw new Error("Failed pattern match at Haskell.Render (line 981, column 1 - line 991, column 22): " + [ v.constructor.name ]);
    });
};
var rendersDeriving = new Renders(function (v) {
    var dclasses = (function () {
        if (v.dclasses instanceof Data_Either.Left) {
            return Data_Functor.map(Control_Monad_Reader_Trans.functorReaderT(Data_Identity.functorIdentity))(Data_Array.singleton)(render(renderToken)(v.dclasses.value0));
        };
        if (v.dclasses instanceof Data_Either.Right) {
            return renders(rendersParens(rendersSepList$prime(renderToken)))(v.dclasses.value0);
        };
        throw new Error("Failed pattern match at Haskell.Render (line 1127, column 20 - line 1129, column 33): " + [ v.dclasses.constructor.name ]);
    })();
    return Control_Apply.lift2(Control_Monad_Reader_Trans.applyReaderT(Data_Identity.applyIdentity))(Data_Array.cons)(render(renderToken)(v.deriving_))(dclasses);
});
var rendersEximport = function (v) {
    if (v instanceof Haskell_AST.ImportFun) {
        return Data_Functor.map(Control_Monad_Reader_Trans.functorReaderT(Data_Identity.functorIdentity))(Data_Array.singleton)(render(renderV)(v.value0));
    };
    if (v instanceof Haskell_AST.ImportCon) {
        return Data_Functor.map(Control_Monad_Reader_Trans.functorReaderT(Data_Identity.functorIdentity))(Data_Array.singleton)(render(renderC)(v.value0));
    };
    if (v instanceof Haskell_AST.ImportConItems) {
        return renderSnoc(renderToken)(rendersAppend(rendersSepList$prime(renderImportItem))(renderTwo(renderC)(renderToken)(v.value0.c)(v.value0.lp_))(v.value0.items))(v.value0.rp_);
    };
    if (v instanceof Haskell_AST.ImportConAll) {
        return renderSnoc(renderToken)(renderSnoc(renderToken)(renderTwo(renderC)(renderToken)(v.value0.c)(v.value0.lp_))(v.value0.dotdot_))(v.value0.rp_);
    };
    throw new Error("Failed pattern match at Haskell.Render (line 726, column 19 - line 730, column 53): " + [ v.constructor.name ]);
};
var renderImport = new Render(function (x) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(rendersEximport(x))(node(new NodeTag("import"))(summaryEximport("import")(x)));
});
var rendersExport = new Renders(function (v) {
    if (v instanceof Haskell_AST.ExportImport) {
        return rendersEximport(v.value0);
    };
    if (v instanceof Haskell_AST.ExportModule) {
        return renderTwo(renderToken)(renderToken)(v.value0.module_)(v.value0.modid);
    };
    throw new Error("Failed pattern match at Haskell.Render (line 714, column 13 - line 716, column 43): " + [ v.constructor.name ]);
});
var renderExport = new Render(function (e) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renders(rendersExport)(e))(node(new NodeTag("export"))(summary(summaryExport)(e)));
});
var rendersExports = new Renders(function (v) {
    return renderSnoc(renderToken)(rendersAppend(rendersMaybe$prime(renderToken))(Control_Apply.lift2(Control_Monad_Reader_Trans.applyReaderT(Data_Identity.applyIdentity))(Data_Array.cons)(render(renderToken)(v.lp_))(renders(rendersSepList$prime(renderExport))(v.exports)))(v.comma_))(v.rp_);
});
var renderExports = new Render(function (e) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renders(rendersExports)(e))(node(new NodeTag("exports"))({
        name: "exports",
        descr: [  ]
    }));
});
var renderModuleHeader = new Render(function (v) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renderSnoc(renderToken)(rendersAppend(rendersMaybe$prime(renderExports))(renderTwo(renderToken)(renderToken)(v.module_)(v.modid))(v.exports))(v.where_))(node(new NodeTag("header"))({
        name: "module header",
        descr: [ headerSyntax ]
    }));
});
var rendersImpSpec = new Renders(function (v) {
    if (v instanceof Haskell_AST.ImportHiding) {
        return renderSnoc(renderToken)(rendersAppend(rendersMaybe$prime(renderToken))(rendersAppend(rendersSepList$prime(renderImport))(renderTwo(renderToken)(renderToken)(v.value0.hiding_)(v.value0.lp_))(v.value0.imports))(v.value0.comma_))(v.value0.rp_);
    };
    if (v instanceof Haskell_AST.ImportExplicit) {
        return renderSnoc(renderToken)(rendersAppend(rendersMaybe$prime(renderToken))(Control_Apply.lift2(Control_Monad_Reader_Trans.applyReaderT(Data_Identity.applyIdentity))(Data_Array.cons)(render(renderToken)(v.value0.lp_))(renders(rendersSepList$prime(renderImport))(v.value0.imports)))(v.value0.comma_))(v.value0.rp_);
    };
    throw new Error("Failed pattern match at Haskell.Render (line 792, column 1 - line 794, column 99): " + [ v.constructor.name ]);
});
var renderImpSpec = new Render(function (x) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renders(rendersImpSpec)(x))(node(new NodeTag("impspec"))(summary(summaryImpSpec)(x)));
});
var rendersImpDecl = new Renders(function (v) {
    return rendersAppend(rendersMaybe$prime(renderImpSpec))(rendersAppend(rendersRenders)(renderSnoc(renderToken)(Control_Apply.lift2(Control_Monad_Reader_Trans.applyReaderT(Data_Identity.applyIdentity))(Data_Array.cons)(render(renderToken)(v.import_))(renders(rendersMaybe$prime(renderToken))(v.qualified_)))(v.modid))(rendersMaybe_(rendersTuple(renderToken)(renderToken))(v.as_)))(v.impspec);
});
var renderImpDecl = new Render(function (x) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renders(rendersImpDecl)(x))(node(new NodeTag("impdecl"))({
        name: "import declaration",
        descr: [  ]
    }));
});
var renderImpDecls = new Render(function (v) {
    var z = {
        name: "import declarations",
        descr: [  ]
    };
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renders(rendersSepList$prime(renderImpDecl))(v))(node(new NodeTag("impdecls"))(z));
});
var rendersSimpleTy = new Renders(function (v) {
    return Control_Apply.lift2(Control_Monad_Reader_Trans.applyReaderT(Data_Identity.applyIdentity))(Data_Array.cons)(render(renderToken)(v.c))(renders(rendersArray(renderTyV))(v.args));
});
var renderSimpleTy = new Render(renderWith(rendersSimpleTy)(new NodeTag("simpletype"))({
    name: "simple type",
    descr: [  ]
}));
var rendersTy = new Renders(function (v) {
    if (v instanceof Haskell_AST.TyVar) {
        return Data_Functor.map(Control_Monad_Reader_Trans.functorReaderT(Data_Identity.functorIdentity))(Data_Array.singleton)(render(renderTyV)(v.value0));
    };
    if (v instanceof Haskell_AST.TyApp) {
        return Control_Apply.lift2(Control_Monad_Reader_Trans.applyReaderT(Data_Identity.applyIdentity))(Data_Array.cons)(render(renderTy)(v.value0.f))(renders(rendersNonEmptyArray(renderTy))(v.value0.args));
    };
    if (v instanceof Haskell_AST.TyPar) {
        return renderSnoc(renderToken)(renderTwo(renderToken)(renderTy)(v.value0.lp_)(v.value0.t))(v.value0.rp_);
    };
    if (v instanceof Haskell_AST.TyArr) {
        return renderSnoc(renderTy)(renderTwo(renderTy)(renderToken)(v.value0.t1)(v.value0.arr_))(v.value0.t2);
    };
    if (v instanceof Haskell_AST.TyTuple) {
        return renderSnoc(renderToken)(Control_Apply.lift2(Control_Monad_Reader_Trans.applyReaderT(Data_Identity.applyIdentity))(Data_Array.cons)(render(renderToken)(v.value0.lp_))(renders(rendersSepList$prime(renderTy))(v.value0.ts)))(v.value0.rp_);
    };
    if (v instanceof Haskell_AST.TyList) {
        return renderSnoc(renderToken)(renderTwo(renderToken)(renderTy)(v.value0.lb_)(v.value0.t))(v.value0.rb_);
    };
    if (v instanceof Haskell_AST.TyGCon) {
        return renders(rendersGTyCon)(v.value0);
    };
    throw new Error("Failed pattern match at Haskell.Render (line 607, column 13 - line 614, column 26): " + [ v.constructor.name ]);
});
var renderTy = new Render(function (t) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renders(rendersTy)(t))(node(new NodeTag("type"))(summary(summaryTy)(t)));
});
var renderBangTy = new Render(function (v) {
    if (v instanceof Haskell_AST.NoBang) {
        return render(renderTy)(v.value0);
    };
    if (v instanceof Haskell_AST.BangTy) {
        return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renderTwo(renderToken)(renderTy)(v.value0.bang_)(v.value0.t))(node(new NodeTag("bangtype"))({
            name: "strict field",
            descr: [  ]
        }));
    };
    throw new Error("Failed pattern match at Haskell.Render (line 1131, column 1 - line 1135, column 20): " + [ v.constructor.name ]);
});
var renderFieldDecl = new Render(function (v) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renderSnoc(renderBangTy)(renderTwo(renderV)(renderToken)(v.field)(v.colons_))(v.t))(node(new NodeTag("fielddecl"))({
        name: "record field declaration",
        descr: [  ]
    }));
});
var renderFieldDecls = new Render(function (v) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renders(rendersSepList$prime(renderFieldDecl))(v))(node(new NodeTag("fielddecls"))({
        name: "record field declarations",
        descr: [  ]
    }));
});
var rendersConstr = new Renders(function (v) {
    if (v instanceof Haskell_AST.ConstrCon) {
        return Control_Apply.lift2(Control_Monad_Reader_Trans.applyReaderT(Data_Identity.applyIdentity))(Data_Array.cons)(render(renderC)(v.value0.c))(renders(rendersArray(renderBangTy))(v.value0.ts));
    };
    if (v instanceof Haskell_AST.ConstrOp) {
        return renderSnoc(renderBangTy)(renderTwo(renderBangTy)(renderCOp)(v.value0.t1)(v.value0.op))(v.value0.t2);
    };
    if (v instanceof Haskell_AST.ConstrRecord) {
        return renderSnoc(renderToken)(renderSnoc(renderFieldDecls)(renderTwo(renderC)(renderToken)(v.value0.c)(v.value0.lb_))(v.value0.fields))(v.value0.rb_);
    };
    throw new Error("Failed pattern match at Haskell.Render (line 1098, column 13 - line 1101, column 54): " + [ v.constructor.name ]);
});
var renderConstr = new Render(renderWith(rendersConstr)(new NodeTag("constr"))({
    name: "constructor definition",
    descr: [ constrSyntax ]
}));
var renderConstrs = new Renders(function (v) {
    return Control_Apply.lift2(Control_Monad_Reader_Trans.applyReaderT(Data_Identity.applyIdentity))(Data_Array.cons)(render(renderToken)(v.eq_))(renders(rendersSepList$prime(renderConstr))(v.constrs));
});
var rendersGenDecl = function (f) {
    return function (v) {
        if (v instanceof Haskell_AST.BaseDecl) {
            return f(v.value0);
        };
        if (v instanceof Haskell_AST.SigDecl) {
            return renderSnoc(renderTy)(renderSnoc(renderToken)(renders(rendersSepList$prime(renderV))(v.value0.vars))(v.value0.colons_))(v.value0.t);
        };
        if (v instanceof Haskell_AST.FixityDecl) {
            return rendersAppend(rendersSepList$prime(renderOp))(Control_Apply.lift2(Control_Monad_Reader_Trans.applyReaderT(Data_Identity.applyIdentity))(Data_Array.cons)(render(renderToken)(v.value0.fixity))(renders(rendersMaybe$prime(renderToken))(v.value0.level)))(v.value0.ops);
        };
        if (v instanceof Haskell_AST.GenDeclEmpty) {
            return Control_Applicative.pure(Control_Monad_Reader_Trans.applicativeReaderT(Data_Identity.applicativeIdentity))([  ]);
        };
        throw new Error("Failed pattern match at Haskell.Render (line 944, column 20 - line 948, column 28): " + [ v.constructor.name ]);
    };
};
var rendersNewconstr = new Renders(function (v) {
    if (v instanceof Haskell_AST.NewconstrCon) {
        return renderTwo(renderC)(renderTy)(v.value0.c)(v.value0.t);
    };
    if (v instanceof Haskell_AST.NewconstrRecord) {
        return renderSnoc(renderToken)(renderSnoc(renderTy)(renderSnoc(renderToken)(renderSnoc(renderV)(renderTwo(renderC)(renderToken)(v.value0.c)(v.value0.lb_))(v.value0.field))(v.value0.colons_))(v.value0.t))(v.value0.rb_);
    };
    throw new Error("Failed pattern match at Haskell.Render (line 1109, column 13 - line 1111, column 74): " + [ v.constructor.name ]);
});
var renderNewconstr = new Render(renderWith(rendersNewconstr)(new NodeTag("newconstr"))({
    name: "newtype constructor definition",
    descr: [  ]
}));
var rendersWhere = function (dictRenders) {
    return new Renders(function (v) {
        return rendersAppend(dictRenders)(Data_Functor.map(Control_Monad_Reader_Trans.functorReaderT(Data_Identity.functorIdentity))(Data_Array.singleton)(render(renderToken)(v.where_)))(v.decls);
    });
};
var renderWhole = function (dictRender) {
    return new Render(function (v) {
        return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(render(dictRender)(v.value))(function (v1) {
            return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renderToken0(v.eof))(function (tokdoc) {
                return Control_Applicative.pure(Control_Monad_Reader_Trans.applicativeReaderT(Data_Identity.applicativeIdentity))({
                    tag: v1.tag,
                    doc: Data_Semigroup.append(semigroupADoc)(v1.doc)(tokdoc)
                });
            });
        });
    });
};
var baseDeclSyntax = new Syntax([ new SyntaxRule("decl", [ new N("lhs"), new N("rhs"), new Grp(Opt01.value, [ new K("where"), new K("{"), new N("decls"), new K("}") ]) ]) ]);
var summaryGenDecl = new Summary(function ($627) {
    return NodeDescr((function (v) {
        if (v instanceof Haskell_AST.BaseDecl) {
            return {
                name: "value clause",
                descr: [ baseDeclSyntax, new Links([ new Report2010("Function and pattern bindings", "https://www.haskell.org/onlinereport/haskell2010/haskellch4.html#x10-830004.4.3") ]) ]
            };
        };
        if (v instanceof Haskell_AST.SigDecl) {
            return {
                name: "type signature",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.FixityDecl) {
            return {
                name: "fixity declaration",
                descr: [  ]
            };
        };
        if (v instanceof Haskell_AST.GenDeclEmpty) {
            return {
                name: "empty declaration",
                descr: [  ]
            };
        };
        throw new Error("Failed pattern match at Haskell.Render (line 954, column 27 - line 973, column 21): " + [ v.constructor.name ]);
    })($627));
});
var summaryCDecl = new Summary(function (v) {
    return summary(summaryGenDecl)(v);
});
var summaryDecl = new Summary(function (v) {
    return summary(summaryGenDecl)(v);
});
var rendersRhs = new Renders(function (v) {
    if (v instanceof Haskell_AST.RhsEq) {
        return renderTwo(renderToken)(renderExp)(v.value0.eq_)(v.value0.e);
    };
    if (v instanceof Haskell_AST.GdRhs_) {
        return renders(rendersNonEmptyArray(renderGdRhs))(v.value0);
    };
    throw new Error("Failed pattern match at Haskell.Render (line 1069, column 1 - line 1071, column 33): " + [ v.constructor.name ]);
});
var rendersExp = new Renders(function (v) {
    if (v instanceof Haskell_AST.If) {
        return renderSnoc(renderExp)(renderSnoc(renderToken)(renderSnoc(renderExp)(renderSnoc(renderToken)(renderTwo(renderToken)(renderExp)(v.value0.if_)(v.value0.e1))(v.value0.then_))(v.value0.e2))(v.value0.else_))(v.value0.e3);
    };
    if (v instanceof Haskell_AST.Fun) {
        return renderSnoc(renderExp)(renderSnoc(renderToken)(renderTwo(renderToken)(renderV)(v.value0.bs_)(v.value0.v))(v.value0.arr_))(v.value0.e);
    };
    if (v instanceof Haskell_AST.Let) {
        return renderSnoc(renderExp)(renderSnoc(renderToken)(Control_Apply.lift2(Control_Monad_Reader_Trans.applyReaderT(Data_Identity.applyIdentity))(Data_Array.cons)(render(renderToken)(v.value0.let_))(renders(rendersDecls)(v.value0.decls)))(v.value0.in_))(v.value0.e);
    };
    if (v instanceof Haskell_AST.Par) {
        return renderSnoc(renderToken)(renderTwo(renderToken)(renderExp)(v.value0.lp_)(v.value0.e))(v.value0.rp_);
    };
    if (v instanceof Haskell_AST.Do) {
        return renderSnoc(renderToken)(renderSnoc$prime(renderTwo(renderToken)(renderToken)(v.value0.do_)(v.value0.lb_))(renderStmts(v.value0.stmts)))(v.value0.rb_);
    };
    if (v instanceof Haskell_AST.Case) {
        return renderSnoc(renderToken)(renderSnoc$prime(renderSnoc(renderToken)(renderSnoc(renderToken)(renderTwo(renderToken)(renderExp)(v.value0.case_)(v.value0.e))(v.value0.of_))(v.value0.lb_))(renderAlts(v.value0.alts)))(v.value0.rb_);
    };
    if (v instanceof Haskell_AST.Record && v.value0.e instanceof Haskell_AST.GCon) {
        return renderSnoc(renderToken)(rendersAppend(rendersSepList$prime(renderField(renderExp)))(renderTwo(renderGCon)(renderToken)(v.value0.e.value0)(v.value0.lb_))(v.value0.fields))(v.value0.rb_);
    };
    if (v instanceof Haskell_AST.Record) {
        return renderSnoc(renderToken)(rendersAppend(rendersSepList$prime(renderField(renderExp)))(renderTwo(renderExp)(renderToken)(v.value0.e)(v.value0.lb_))(v.value0.fields))(v.value0.rb_);
    };
    if (v instanceof Haskell_AST.Infix) {
        return renderSnoc(renderExp)(renderTwo(renderExp)(renderOp)(v.value0.e1)(v.value0.op))(v.value0.e2);
    };
    if (v instanceof Haskell_AST.LSection) {
        return renderSnoc(renderToken)(renderSnoc(renderOp)(renderTwo(renderToken)(renderExp)(v.value0.lp_)(v.value0.e))(v.value0.op))(v.value0.rp_);
    };
    if (v instanceof Haskell_AST.RSection) {
        return renderSnoc(renderToken)(renderSnoc(renderExp)(renderTwo(renderToken)(renderOp)(v.value0.lp_)(v.value0.op))(v.value0.e))(v.value0.rp_);
    };
    if (v instanceof Haskell_AST.App) {
        return rendersAppend(rendersNonEmptyArray(renderExp))(renderSnoc(renderExp)(Data_Monoid.mempty(Control_Monad_Reader_Trans.monoidReaderT(Data_Identity.applicativeIdentity)(Data_Monoid.monoidArray)))(v.value0.f))(v.value0.args);
    };
    if (v instanceof Haskell_AST.Negate) {
        return renderTwo(renderToken)(renderExp)(v.value0.minus_)(v.value0.e);
    };
    if (v instanceof Haskell_AST.HasType) {
        return renderSnoc(renderTy)(renderTwo(renderExp)(renderToken)(v.value0.e)(v.value0.colons_))(v.value0.t);
    };
    if (v instanceof Haskell_AST.Var) {
        return Data_Functor.map(Control_Monad_Reader_Trans.functorReaderT(Data_Identity.functorIdentity))(Data_Array.singleton)(render(renderV)(v.value0));
    };
    if (v instanceof Haskell_AST.List) {
        return renderSnoc(renderToken)(rendersAppend(rendersSepList$prime(renderExp))(renderSnoc(renderToken)(Data_Monoid.mempty(Control_Monad_Reader_Trans.monoidReaderT(Data_Identity.applicativeIdentity)(Data_Monoid.monoidArray)))(v.value0.lb_))(v.value0.es))(v.value0.rb_);
    };
    if (v instanceof Haskell_AST.EnumList) {
        var to = Data_Foldable.foldMap(Data_Foldable.foldableMaybe)(Control_Monad_Reader_Trans.monoidReaderT(Data_Identity.applicativeIdentity)(Data_Monoid.monoidArray))(function (z) {
            return Data_Functor.map(Control_Monad_Reader_Trans.functorReaderT(Data_Identity.functorIdentity))(Data_Array.singleton)(render(renderExp)(z));
        })(v.value0.to);
        var then_ = Data_Foldable.foldMap(Data_Foldable.foldableMaybe)(Control_Monad_Reader_Trans.monoidReaderT(Data_Identity.applicativeIdentity)(Data_Monoid.monoidArray))(function (v1) {
            return renderTwo(renderToken)(renderExp)(v1.value0)(v1.value1);
        })(v.value0.then_);
        return renderSnoc(renderToken)(rendersAppend$prime(renderSnoc(renderToken)(rendersAppend$prime(renderTwo(renderToken)(renderExp)(v.value0.lb_)(v.value0.from))(then_))(v.value0.dotdot_))(to))(v.value0.rb_);
    };
    if (v instanceof Haskell_AST.ListComp) {
        return renderSnoc(renderToken)(rendersAppend(rendersSepList$prime(renderQual))(renderSnoc(renderToken)(renderTwo(renderToken)(renderExp)(v.value0.lb_)(v.value0.e))(v.value0.vbar_))(v.value0.quals))(v.value0.rb_);
    };
    if (v instanceof Haskell_AST.Tuple) {
        return renderSnoc(renderToken)(rendersAppend(rendersSepList$prime(renderExp))(renderSnoc(renderToken)(Data_Monoid.mempty(Control_Monad_Reader_Trans.monoidReaderT(Data_Identity.applicativeIdentity)(Data_Monoid.monoidArray)))(v.value0.lp_))(v.value0.es))(v.value0.rp_);
    };
    if (v instanceof Haskell_AST.Lit) {
        return Data_Functor.map(Control_Monad_Reader_Trans.functorReaderT(Data_Identity.functorIdentity))(Data_Array.singleton)(render(renderLiteral)(v.value0));
    };
    if (v instanceof Haskell_AST.GCon) {
        return Data_Functor.map(Control_Monad_Reader_Trans.functorReaderT(Data_Identity.functorIdentity))(Data_Array.singleton)(render(renderGCon)(v.value0));
    };
    if (v instanceof Haskell_AST.ExpInfo) {
        return renders(rendersExp)(v.value1);
    };
    throw new Error("Failed pattern match at Haskell.Render (line 376, column 13 - line 401, column 29): " + [ v.constructor.name ]);
});
var rendersDecls = new Renders(function (v) {
    var nodeDecls = Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renders(rendersSepList$prime(renderDecl))(v.decls))(node(new NodeTag("decls"))({
        name: "decls",
        descr: [  ]
    }));
    return Control_Apply.lift3(Control_Monad_Reader_Trans.applyReaderT(Data_Identity.applyIdentity))(function (a) {
        return function (b) {
            return function (c) {
                return [ a, b, c ];
            };
        };
    })(render(renderToken)(v.lb_))(nodeDecls)(render(renderToken)(v.rb_));
});
var rendersDecl = new Renders(function (v) {
    return rendersGenDecl(function (x) {
        return rendersAppend$prime(renderTwo(renderLhs_(renderPat))(renderRhs)(x.lhs)(x.rhs))(rendersMaybe_(rendersWhere(rendersDecls))(x.where_));
    })(v);
});
var renderStmts = function (x) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renders(rendersSepList$prime(renderStmt))(x))(node(new NodeTag("stmts"))({
        name: "stmts",
        descr: [  ]
    }));
};
var renderStmt = new Render(function (v) {
    if (v instanceof Haskell_AST.EmptyStmt) {
        return Control_Applicative.pure(Control_Monad_Reader_Trans.applicativeReaderT(Data_Identity.applicativeIdentity))({
            tag: new NodeTag("stmt"),
            doc: Data_Monoid.mempty(monoidADoc)
        });
    };
    if (v instanceof Haskell_AST.Stmt) {
        return Control_Bind.bindFlipped(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(node(new NodeTag("stmt"))(summaryStmt(v.value0)))(renderGuard_(v.value0));
    };
    throw new Error("Failed pattern match at Haskell.Render (line 503, column 1 - line 505, column 77): " + [ v.constructor.name ]);
});
var renderRhs = new Render(renderWith(rendersRhs)(new NodeTag("rhs"))({
    name: "rhs",
    descr: [  ]
}));
var renderQual = new Render(function (v) {
    return Control_Bind.bindFlipped(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(node(new NodeTag("qual"))(summary(summaryQual)(v)))(renderGuard_(v));
});
var renderGuards = new Render(function (v) {
    var z = {
        name: "guards",
        descr: [  ]
    };
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renders(rendersSepList$prime(renderGuard))(v))(node(new NodeTag("guards"))(z));
});
var renderGuard_ = function (v) {
    if (v instanceof Haskell_AST.GuardPat) {
        return Data_Traversable.sequence(Data_Traversable.traversableArray)(Control_Monad_Reader_Trans.applicativeReaderT(Data_Identity.applicativeIdentity))([ render(renderPat)(v.value0.p), render(renderToken)(v.value0.leftarr_), render(renderExp)(v.value0.e) ]);
    };
    if (v instanceof Haskell_AST.GuardLet) {
        return Control_Apply.lift2(Control_Monad_Reader_Trans.applyReaderT(Data_Identity.applyIdentity))(Data_Array.cons)(render(renderToken)(v.value0.let_))(renders(rendersDecls)(v.value0.decls));
    };
    if (v instanceof Haskell_AST.GuardBool) {
        return Data_Traversable.sequence(Data_Traversable.traversableArray)(Control_Monad_Reader_Trans.applicativeReaderT(Data_Identity.applicativeIdentity))([ render(renderExp)(v.value0) ]);
    };
    throw new Error("Failed pattern match at Haskell.Render (line 565, column 16 - line 568, column 37): " + [ v.constructor.name ]);
};
var renderGuard = new Render(function (g) {
    return Control_Bind.bindFlipped(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(node(new NodeTag("guard"))(summary(summaryGuard)(g)))(renderGuard_(g));
});
var renderGdRhs = new Render(function (v) {
    return render(renderGdPat)(v);
});
var renderGdPat = new Render(function (v) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renderSnoc(renderExp)(renderSnoc(renderToken)(renderTwo(renderToken)(renderGuards)(v.vbar_)(v.guards))(v.arr_))(v.e))(node(new NodeTag("gdpat"))({
        name: "subalternative",
        descr: [  ]
    }));
});
var renderExp = new Render(function (v) {
    if (v instanceof Haskell_AST.ExpInfo) {
        return Data_Functor.map(Control_Monad_Reader_Trans.functorReaderT(Data_Identity.functorIdentity))(renderInfo(v.value0))(render(renderExp)(v.value1));
    };
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renders(rendersExp)(v))(node(new NodeTag("exp"))(summary(summaryExp)(v)));
});
var renderDecl = new Render(function (d) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renders(rendersDecl)(d))(node(new NodeTag("decl"))(summary(summaryDecl)(d)));
});
var renderAlts = function (x) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renders(rendersSepList$prime(renderAlt))(x))(node(new NodeTag("alts"))({
        name: "alts",
        descr: [  ]
    }));
};
var renderAlt = new Render(function (a) {
    return Control_Bind.bindFlipped(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(node(new NodeTag("alt"))(summary(summaryAlt)(a)))((function () {
        if (a instanceof Haskell_AST.AltSimple) {
            return rendersAppend$prime(renderSnoc(renderExp)(renderTwo(renderPat)(renderToken)(a.value0.p)(a.value0.arr_))(a.value0.e))(rendersMaybe_(rendersWhere(rendersDecls))(a.value0.where_));
        };
        if (a instanceof Haskell_AST.AltGuard) {
            return rendersAppend$prime(rendersAppend(rendersNonEmptyArray(renderGdPat))(renderSnoc(renderPat)(Data_Monoid.mempty(Control_Monad_Reader_Trans.monoidReaderT(Data_Identity.applicativeIdentity)(Data_Monoid.monoidArray)))(a.value0.p))(a.value0.gdpats))(rendersMaybe_(rendersWhere(rendersDecls))(a.value0.where_));
        };
        if (a instanceof Haskell_AST.AltEmpty) {
            return Data_Monoid.mempty(Control_Monad_Reader_Trans.monoidReaderT(Data_Identity.applicativeIdentity)(Data_Monoid.monoidArray));
        };
        throw new Error("Failed pattern match at Haskell.Render (line 528, column 51 - line 531, column 23): " + [ a.constructor.name ]);
    })());
});
var rendersCDecl = new Renders(function (v) {
    return rendersGenDecl(function (x) {
        return rendersAppend$prime(renderTwo(renderLhs_(renderV))(renderRhs)(x.lhs)(x.rhs))(rendersMaybe_(rendersWhere(rendersDecls))(x.where_));
    })(v);
});
var renderCDecl = new Render(function (d) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renders(rendersCDecl)(d))(node(new NodeTag("cdecl"))(summary(summaryCDecl)(d)));
});
var rendersCDecls = new Renders(function (v) {
    var nodeDecls = Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renders(rendersSepList$prime(renderCDecl))(v.decls))(node(new NodeTag("cdecls"))({
        name: "cdecls",
        descr: [  ]
    }));
    return Control_Apply.lift3(Control_Monad_Reader_Trans.applyReaderT(Data_Identity.applyIdentity))(function (a) {
        return function (b) {
            return function (c) {
                return [ a, b, c ];
            };
        };
    })(render(renderToken)(v.lb_))(nodeDecls)(render(renderToken)(v.rb_));
});
var rendersIDecl = new Renders(function (v) {
    if (v instanceof Haskell_AST.IDecl) {
        return rendersAppend$prime(renderTwo(renderLhs_(renderV))(renderRhs)(v.value0.lhs)(v.value0.rhs))(rendersMaybe_(rendersWhere(rendersDecls))(v.value0.where_));
    };
    if (v instanceof Haskell_AST.IDeclEmpty) {
        return Control_Applicative.pure(Control_Monad_Reader_Trans.applicativeReaderT(Data_Identity.applicativeIdentity))([  ]);
    };
    throw new Error("Failed pattern match at Haskell.Render (line 911, column 1 - line 913, column 31): " + [ v.constructor.name ]);
});
var renderIDecl = new Render(function (d) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renders(rendersIDecl)(d))(node(new NodeTag("idecl"))(summary(summaryIDecl)(d)));
});
var rendersIDecls = new Renders(function (v) {
    var nodeDecls = Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renders(rendersSepList$prime(renderIDecl))(v.decls))(node(new NodeTag("idecls"))({
        name: "idecls",
        descr: [  ]
    }));
    return Control_Apply.lift3(Control_Monad_Reader_Trans.applyReaderT(Data_Identity.applyIdentity))(function (a) {
        return function (b) {
            return function (c) {
                return [ a, b, c ];
            };
        };
    })(render(renderToken)(v.lb_))(nodeDecls)(render(renderToken)(v.rb_));
});
var rendersTopDecl = new Renders(function (v) {
    if (v instanceof Haskell_AST.Decl_) {
        return Data_Functor.map(Control_Monad_Reader_Trans.functorReaderT(Data_Identity.functorIdentity))(Data_Array.singleton)(render(renderDecl)(v.value0));
    };
    if (v instanceof Haskell_AST.TypeDecl) {
        return renderSnoc(renderTy)(renderSnoc(renderToken)(renderTwo(renderToken)(renderSimpleTy)(v.value0.type_)(v.value0.stype))(v.value0.eq_))(v.value0.t);
    };
    if (v instanceof Haskell_AST.DataDecl) {
        return rendersAppend$prime(rendersAppend$prime(renderTwo(renderToken)(renderSimpleTy)(v.value0.data_)(v.value0.stype))(rendersMaybe_(renderConstrs)(v.value0.constrs)))(rendersMaybe_(rendersDeriving)(v.value0.deriving));
    };
    if (v instanceof Haskell_AST.NewtypeDecl) {
        return rendersAppend$prime(renderSnoc(renderNewconstr)(renderSnoc(renderToken)(renderTwo(renderToken)(renderSimpleTy)(v.value0.newtype_)(v.value0.stype))(v.value0.eq_))(v.value0.newconstr))(rendersMaybe_(rendersDeriving)(v.value0.deriving));
    };
    if (v instanceof Haskell_AST.ClassDecl) {
        return rendersAppend$prime(renderSnoc(renderToken)(renderTwo(renderToken)(renderToken)(v.value0.class_)(v.value0.tycls))(v.value0.arg))(rendersMaybe_(rendersWhere(rendersCDecls))(v.value0.where_));
    };
    if (v instanceof Haskell_AST.InstDecl) {
        return rendersAppend$prime(renderSnoc(renderTy)(renderTwo(renderToken)(renderToken)(v.value0.instance_)(v.value0.qtycls))(v.value0.arg))(rendersMaybe_(rendersWhere(rendersIDecls))(v.value0.where_));
    };
    if (v instanceof Haskell_AST.DefaultDecl) {
        return renderSnoc(renderToken)(rendersAppend(rendersSepList$prime(renderTy))(renderTwo(renderToken)(renderToken)(v.value0.default_)(v.value0.lp_))(v.value0.ts))(v.value0.rp_);
    };
    throw new Error("Failed pattern match at Haskell.Render (line 821, column 13 - line 828, column 57): " + [ v.constructor.name ]);
});
var renderTopDecl = new Render(function (d) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renders(rendersTopDecl)(d))(node(new NodeTag("topdecl"))(summary(summaryTopDecl)(d)));
});
var renderTopDecls = new Render(function (v) {
    var z = {
        name: "topdecls",
        descr: [  ]
    };
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renders(rendersSepList$prime(renderTopDecl))(v))(node(new NodeTag("topdecls"))(z));
});
var rendersModuleBody = new Renders(function (v) {
    var v1 = function (v2) {
        var v3 = function (v4) {
            if (Data_Boolean.otherwise) {
                return renderSnoc(renderToken)(renderSnoc(renderTopDecls)(rendersAppend(rendersMaybe$prime(renderToken))(renderTwo(renderToken)(renderImpDecls)(v.lb_)(v.impdecls))(v.sc_))(v.topdecls))(v.rb_);
            };
            throw new Error("Failed pattern match at Haskell.Render (line 766, column 1 - line 770, column 68): " + [ v.constructor.name ]);
        };
        if (v.sc_ instanceof Data_Maybe.Nothing) {
            if (v.topdecls instanceof Haskell_AST.SepNil) {
                return renderSnoc(renderToken)(renderTwo(renderToken)(renderTopDecls)(v.lb_)(v.topdecls))(v.rb_);
            };
            return v3(true);
        };
        return v3(true);
    };
    if (v.sc_ instanceof Data_Maybe.Nothing) {
        if (v.impdecls instanceof Haskell_AST.SepNil) {
            return renderSnoc(renderToken)(renderTwo(renderToken)(renderTopDecls)(v.lb_)(v.topdecls))(v.rb_);
        };
        return v1(true);
    };
    return v1(true);
});
var renderModuleBody = new Render(function (m) {
    return Control_Bind.bind(Control_Monad_Reader_Trans.bindReaderT(Data_Identity.bindIdentity))(renders(rendersModuleBody)(m))(node(new NodeTag("modulebody"))({
        name: "module body",
        descr: [  ]
    }));
});
var rendersModule = new Renders(function (v) {
    return renderSnoc(renderModuleBody)(renders(rendersMaybe$prime(renderModuleHeader))(v.header))(v.body);
});
var renderModule = new Render(renderWith(rendersModule)(new NodeTag("module"))({
    name: "module",
    descr: [  ]
}));
var anyM = function (dictFoldable) {
    return function (dictMonad) {
        return function (f) {
            var go = function (x) {
                return function (etc) {
                    return Control_Bind.bind(dictMonad.Bind1())(f(x))(function (v) {
                        if (v) {
                            return Control_Applicative.pure(dictMonad.Applicative0())(true);
                        };
                        return etc;
                    });
                };
            };
            return Data_Foldable.foldr(dictFoldable)(go)(Control_Applicative.pure(dictMonad.Applicative0())(false));
        };
    };
};
module.exports = {
    render: render,
    renders: renders,
    summary: summary,
    classes: classes,
    Idle: Idle,
    Focused: Focused,
    info: info,
    info_: info_,
    "eqToken'": eqToken$prime,
    Ahead: Ahead,
    ADoc: ADoc,
    Match: Match,
    NoMatch: NoMatch,
    NodeDescr: NodeDescr,
    Syntax: Syntax,
    Links: Links,
    SyntaxRule: SyntaxRule,
    N: N,
    T: T,
    K: K,
    Grp: Grp,
    Opt01: Opt01,
    Star: Star,
    Plus: Plus,
    SClass: SClass,
    Report2010: Report2010,
    Click: Click,
    Hover: Hover,
    Unhover: Unhover,
    NodeHover: NodeHover,
    NodeUnhover: NodeUnhover,
    handleAction: handleAction,
    incMatch: incMatch,
    runRenderM: runRenderM,
    matchItem: matchItem,
    renderDescr: renderDescr,
    renderLink: renderLink,
    renderRule: renderRule,
    srClass: srClass,
    renderRule_: renderRule_,
    showQuantifier: showQuantifier,
    qC: qC,
    prettySpace: prettySpace,
    isSpecial: isSpecial,
    syntaxNode: syntaxNode,
    matchingADoc: matchingADoc,
    Node: Node,
    NodeToken: NodeToken,
    NodeTag: NodeTag,
    node: node,
    renderInfo: renderInfo,
    infotagC: infotagC,
    Render: Render,
    Renders: Renders,
    Summary: Summary,
    renderSnoc: renderSnoc,
    "renderSnoc'": renderSnoc$prime,
    renderTwo: renderTwo,
    "renderTwo'": renderTwo$prime,
    "renderSnocMaybe'": renderSnocMaybe$prime,
    "rendersAppend'": rendersAppend$prime,
    rendersAppend: rendersAppend,
    renderStmts: renderStmts,
    summaryStmt: summaryStmt,
    renderAlts: renderAlts,
    renderGuard_: renderGuard_,
    summaryGTyCon: summaryGTyCon,
    renderWith: renderWith,
    headerSyntax: headerSyntax,
    rendersEximport: rendersEximport,
    summaryEximport: summaryEximport,
    rendersGenDecl: rendersGenDecl,
    baseDeclSyntax: baseDeclSyntax,
    constrSyntax: constrSyntax,
    rendersSepList: rendersSepList,
    rendersMaybe: rendersMaybe,
    rendersMaybe_: rendersMaybe_,
    rendersFoldable: rendersFoldable,
    incMatchOf: incMatchOf,
    renderToken0: renderToken0,
    renderSubtokens: renderSubtokens,
    renderSubtoken: renderSubtoken,
    match0: match0,
    renderToken_: renderToken_,
    ghostC: ghostC,
    ghostData: ghostData,
    tagC: tagC,
    tokenC: tokenC,
    spaceC: spaceC,
    bolC: bolC,
    focusedC: focusedC,
    secondaryC: secondaryC,
    levelC: levelC,
    positionLT: positionLT,
    Highlight: Highlight,
    anyM: anyM,
    matchToken: matchToken,
    newtypeAhead: newtypeAhead,
    semigroupAhead: semigroupAhead,
    monoidAhead: monoidAhead,
    newtypeADoc: newtypeADoc,
    semigroupADoc: semigroupADoc,
    monoidADoc: monoidADoc,
    semigroupMatch: semigroupMatch,
    monoidMatch: monoidMatch,
    renderRender: renderRender,
    rendersRenders: rendersRenders,
    renderExp: renderExp,
    rendersExp: rendersExp,
    summaryExp: summaryExp,
    renderLiteral: renderLiteral,
    renderGCon: renderGCon,
    summaryGCon: summaryGCon,
    renderStmt: renderStmt,
    renderAlt: renderAlt,
    summaryAlt: summaryAlt,
    renderGdPat: renderGdPat,
    renderGuards: renderGuards,
    renderQual: renderQual,
    renderGuard: renderGuard,
    summaryQual: summaryQual,
    summaryGuard: summaryGuard,
    renderField: renderField,
    renderTy: renderTy,
    rendersTy: rendersTy,
    rendersGTyCon: rendersGTyCon,
    summaryTy: summaryTy,
    renderSimpleTy: renderSimpleTy,
    rendersSimpleTy: rendersSimpleTy,
    renderModule: renderModule,
    rendersModule: rendersModule,
    renderModuleHeader: renderModuleHeader,
    renderExports: renderExports,
    rendersExports: rendersExports,
    renderExport: renderExport,
    rendersExport: rendersExport,
    summaryExport: summaryExport,
    renderImportItem: renderImportItem,
    renderModuleBody: renderModuleBody,
    rendersModuleBody: rendersModuleBody,
    renderImpDecls: renderImpDecls,
    renderImpDecl: renderImpDecl,
    rendersImpDecl: rendersImpDecl,
    renderImpSpec: renderImpSpec,
    rendersImpSpec: rendersImpSpec,
    summaryImpSpec: summaryImpSpec,
    renderImport: renderImport,
    renderTopDecls: renderTopDecls,
    renderTopDecl: renderTopDecl,
    rendersTopDecl: rendersTopDecl,
    summaryTopDecl: summaryTopDecl,
    rendersCDecls: rendersCDecls,
    renderCDecl: renderCDecl,
    rendersCDecl: rendersCDecl,
    summaryCDecl: summaryCDecl,
    rendersIDecls: rendersIDecls,
    renderIDecl: renderIDecl,
    rendersIDecl: rendersIDecl,
    summaryIDecl: summaryIDecl,
    rendersDecls: rendersDecls,
    renderDecl: renderDecl,
    rendersDecl: rendersDecl,
    summaryDecl: summaryDecl,
    summaryGenDecl: summaryGenDecl,
    renderLhs_: renderLhs_,
    renderPat: renderPat,
    summaryPat: summaryPat,
    renderFunLhs: renderFunLhs,
    rendersFunLhs: rendersFunLhs,
    renderRhs: renderRhs,
    rendersRhs: rendersRhs,
    renderGdRhs: renderGdRhs,
    rendersWhere: rendersWhere,
    renderConstrs: renderConstrs,
    renderConstr: renderConstr,
    rendersConstr: rendersConstr,
    renderNewconstr: renderNewconstr,
    rendersNewconstr: rendersNewconstr,
    renderFieldDecls: renderFieldDecls,
    renderFieldDecl: renderFieldDecl,
    rendersDeriving: rendersDeriving,
    renderBangTy: renderBangTy,
    "rendersSepList'": rendersSepList$prime,
    renderC: renderC,
    renderV: renderV,
    renderCOp: renderCOp,
    renderVOp: renderVOp,
    renderOp: renderOp,
    renderTyV: renderTyV,
    renderWhole: renderWhole,
    rendersParens: rendersParens,
    rendersList: rendersList,
    rendersNonEmpty: rendersNonEmpty,
    rendersNonEmptyArray: rendersNonEmptyArray,
    "rendersMaybe'": rendersMaybe$prime,
    rendersArray: rendersArray,
    rendersTuple: rendersTuple,
    renderToken: renderToken
};
